import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Checkbox } from '../../components/ui/checkbox';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../components/ui/tooltip';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Progress } from '../../components/ui/progress';
import { Slider } from '../../components/ui/slider';
import { ScrollArea } from '../../components/ui/scroll-area';
import { 
  Briefcase, Plus, Loader2, Trash2, Edit, Eye, Building2, Calendar, MapPin, Users,
  CheckCircle, Clock, XCircle, X, FileText, CalendarDays, ClipboardList, AlertCircle,
  Upload, Download, FileIcon, Image, File, Archive, RotateCcw, Percent,
  ArrowUp, ArrowDown, ArrowUpDown, History, MessageSquare, Send, Inbox
} from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('fortis_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const HRJobs = ({ readOnly = false }) => {
  const [jobs, setJobs] = useState([]);
  const [archivedJobs, setArchivedJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [cancellationReason, setCancellationReason] = useState('');
  const [selectedJob, setSelectedJob] = useState(null);
  const [hrUsers, setHrUsers] = useState([]);
  const [statusFilter, setStatusFilter] = useState('all');
  const [activeTab, setActiveTab] = useState('active');
  
  // Sıralama state'i
  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'desc' });
  
  // İlerleme modal state'i
  const [progressModalOpen, setProgressModalOpen] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  
  // İşe bağlı öğeler için state'ler
  const [reportsModalOpen, setReportsModalOpen] = useState(false);
  const [schedulesModalOpen, setSchedulesModalOpen] = useState(false);
  const [tasksModalOpen, setTasksModalOpen] = useState(false);
  const [jobReports, setJobReports] = useState([]);
  const [jobSchedules, setJobSchedules] = useState([]);
  const [jobTasks, setJobTasks] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);
  
  // Ekleme form state'leri
  const [addReportOpen, setAddReportOpen] = useState(false);
  const [addScheduleOpen, setAddScheduleOpen] = useState(false);
  const [addTaskOpen, setAddTaskOpen] = useState(false);
  const [newReport, setNewReport] = useState({ title: '', content: '', report_type: 'general' });
  const [newSchedule, setNewSchedule] = useState({ title: '', description: '', scheduled_date: '', scheduled_time: '' });
  const [newTask, setNewTask] = useState({ title: '', description: '', assigned_to: '', due_date: '', priority: 'normal' });
  
  // Belge yükleme state'leri
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewDoc, setPreviewDoc] = useState(null);
  
  // İş belgesi yükleme state'leri (form için)
  const [jobDocuments, setJobDocuments] = useState([]);
  const [pendingJobDocuments, setPendingJobDocuments] = useState([]);
  const [jobDocumentsLoading, setJobDocumentsLoading] = useState(false);
  
  // Detay modal state'leri
  const [reportDetailModal, setReportDetailModal] = useState(false);
  const [scheduleDetailModal, setScheduleDetailModal] = useState(false);
  const [taskDetailModal, setTaskDetailModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [itemDocuments, setItemDocuments] = useState([]);
  
  // Görev güncelleme state'leri
  const [taskUpdateModal, setTaskUpdateModal] = useState(false);
  const [taskUpdateText, setTaskUpdateText] = useState('');
  const [taskUpdateFiles, setTaskUpdateFiles] = useState([]);
  const [submittingTaskUpdate, setSubmittingTaskUpdate] = useState(false);
  const [completingTask, setCompletingTask] = useState(false);
  
  // İş Programı güncelleme state'leri
  const [scheduleUpdateModal, setScheduleUpdateModal] = useState(false);
  const [scheduleUpdateText, setScheduleUpdateText] = useState('');
  const [scheduleUpdateFiles, setScheduleUpdateFiles] = useState([]);
  const [submittingScheduleUpdate, setSubmittingScheduleUpdate] = useState(false);
  const [completingSchedule, setCompletingSchedule] = useState(false);
  
  // Talepler state'leri
  const [incomingRequests, setIncomingRequests] = useState([]);
  const [completedJobs, setCompletedJobs] = useState([]);
  const [cancelledJobs, setCancelledJobs] = useState([]);
  const [myRequests, setMyRequests] = useState([]); // Kullanıcının kendi talepleri
  const [taleplerSubTab, setTaleplerSubTab] = useState('gelen');
  const [selectedTalep, setSelectedTalep] = useState(null);
  const [talepActionLoading, setTalepActionLoading] = useState(false);
  const [talepActionNote, setTalepActionNote] = useState('');
  const [talepSortConfig, setTalepSortConfig] = useState({ key: 'created_at', direction: 'desc' });
  const [convertToJobModalOpen, setConvertToJobModalOpen] = useState(false); // Onayla ve İşe Çevir modal
  const [convertJobSubmitting, setConvertJobSubmitting] = useState(false);
  const [convertJobFormData, setConvertJobFormData] = useState({
    name: '',
    description: '',
    company: '',
    start_date: new Date().toISOString().split('T')[0],
    estimated_end_date: '',
    locations: [''],
    tracking_users: []
  });
  
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    tracking_users: [],
    company: '',
    start_date: new Date().toISOString().split('T')[0],
    estimated_end_date: '',
    locations: [''],
    description: '',
    status: 'active'
  });

  useEffect(() => {
    if (activeTab === 'archive') {
      loadArchivedJobs();
    } else if (activeTab === 'completed') {
      loadCompletedJobs();
    } else if (activeTab === 'cancelled') {
      loadCancelledJobs();
    } else if (activeTab === 'talepler') {
      loadIncomingRequests();
      loadMyRequests();
    } else {
      loadJobs();
    }
    loadHrUsers();
  }, [activeTab]);

  const loadJobs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/hr/jobs`, { headers: getAuthHeaders() });
      setJobs(res.data || []);
    } catch (error) {
      console.error('İşler yüklenirken hata:', error);
      toast.error('İşler yüklenemedi');
    }
    setLoading(false);
  };

  const loadArchivedJobs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/hr/jobs/archived`, { headers: getAuthHeaders() });
      setArchivedJobs(res.data || []);
    } catch (error) {
      console.error('Arşivlenmiş işler yüklenirken hata:', error);
      toast.error('Arşivlenmiş işler yüklenemedi');
    }
    setLoading(false);
  };

  const loadCompletedJobs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/hr/jobs?status=completed`, { headers: getAuthHeaders() });
      setCompletedJobs(res.data || []);
    } catch (error) {
      console.error('Tamamlanan işler yüklenirken hata:', error);
    }
    setLoading(false);
  };

  const loadCancelledJobs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/hr/jobs?status=cancelled`, { headers: getAuthHeaders() });
      setCancelledJobs(res.data || []);
    } catch (error) {
      console.error('İptal edilen işler yüklenirken hata:', error);
    }
    setLoading(false);
  };


  // İK'ya gelen talepleri yükle
  const loadIncomingRequests = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/hr/incoming-requests`, { headers: getAuthHeaders() });
      setIncomingRequests(res.data || []);
    } catch (error) {
      console.error('Gelen talepler yüklenirken hata:', error);
    }
    setLoading(false);
  };

  // Kullanıcının kendi taleplerini yükle
  const loadMyRequests = async () => {
    try {
      const res = await axios.get(`${API}/work/requests/my`, { headers: getAuthHeaders() });
      setMyRequests(res.data || []);
    } catch (error) {
      console.error('Taleplerim yüklenirken hata:', error);
    }
  };

  // Talep işlemleri
  const handleTalepAction = async (actionType) => {
    if (!selectedTalep) return;
    
    setTalepActionLoading(true);
    try {
      let newStatus = '';
      
      if (actionType === 'approve') {
        newStatus = 'approved';
      } else if (actionType === 'complete') {
        newStatus = 'completed';
      } else if (actionType === 'reject') {
        newStatus = 'rejected_by_hr';
      }
      
      await axios.put(`${API}/work/requests/${selectedTalep.id}`, {
        status: newStatus,
        response_message: talepActionNote
      }, { headers: getAuthHeaders() });
      
      const actionMessages = {
        'approve': 'Talep onaylandı',
        'complete': 'Talep tamamlandı',
        'reject': 'Talep reddedildi'
      };
      
      toast.success(actionMessages[actionType]);
      setSelectedTalep(null);
      setTalepActionNote('');
      loadIncomingRequests();
    } catch (error) {
      console.error('Talep işlemi hatası:', error);
      toast.error('Talep işlemi başarısız');
    }
    setTalepActionLoading(false);
  };

  // Onayla ve İşe Çevir
  const handleApproveAndConvertToJob = () => {
    if (!selectedTalep) return;
    
    // Talebin bilgilerini form'a doldur
    setConvertJobFormData({
      name: selectedTalep.title || '',
      description: selectedTalep.description || '',
      company: '',
      start_date: new Date().toISOString().split('T')[0],
      estimated_end_date: '',
      locations: [''],
      tracking_users: []
    });
    
    // İşe çevir modalını aç
    setConvertToJobModalOpen(true);
  };

  // Onayla ve İşe Çevir Submit
  const handleSubmitConvertToJob = async () => {
    if (!convertJobFormData.name.trim()) {
      toast.error('İşin adı zorunludur');
      return;
    }
    if (!convertJobFormData.company.trim()) {
      toast.error('Şirket adı zorunludur');
      return;
    }
    if (!selectedTalep) return;
    
    setConvertJobSubmitting(true);
    try {
      // 1. İşi oluştur
      const payload = {
        ...convertJobFormData,
        locations: convertJobFormData.locations.filter(loc => loc.trim() !== ''),
        source_request_id: selectedTalep.id,
        source_request: {
          id: selectedTalep.id,
          request_number: selectedTalep.request_number,
          title: selectedTalep.title,
          category: selectedTalep.category,
          owner_name: selectedTalep.owner_name
        }
      };
      
      const jobResponse = await axios.post(`${API}/hr/jobs`, payload, { headers: getAuthHeaders() });
      
      if (!jobResponse.data) {
        toast.error('İş oluşturulamadı');
        setConvertJobSubmitting(false);
        return;
      }
      
      // 2. Talebi "converted_to_job" olarak işaretle
      await axios.put(`${API}/work/requests/${selectedTalep.id}`, {
        status: 'converted_to_job',
        response_message: 'İşe dönüştürüldü'
      }, { headers: getAuthHeaders() });
      
      toast.success('Talep onaylandı ve iş olarak eklendi');
      setConvertToJobModalOpen(false);
      setSelectedTalep(null);
      setConvertJobFormData({
        name: '',
        description: '',
        company: '',
        start_date: new Date().toISOString().split('T')[0],
        estimated_end_date: '',
        locations: [''],
        tracking_users: []
      });
      loadIncomingRequests();
      loadJobs();
      setActiveTab('active');
    } catch (error) {
      console.error('İşe dönüştürme hatası:', error);
      toast.error('İşe dönüştürme başarısız');
    }
    setConvertJobSubmitting(false);
  };

  // Talep filtreleme - BranchJobs.js yapısına uygun
  const getFilteredTalepler = () => {
    let filtered;
    if (taleplerSubTab === 'gelen') {
      // İK'ya gelen talepler
      filtered = incomingRequests.filter(r => r.status === 'forwarded_to_hr' || r.status === 'pending_hr' || r.status === 'pending');
    } else if (taleplerSubTab === 'onayladigim') {
      // Onayladığım talepler (converted_to_job dahil)
      filtered = incomingRequests.filter(r => r.status === 'approved' || r.status === 'converted_to_job' || r.status?.startsWith('forwarded_to_'));
    } else if (taleplerSubTab === 'bitirilen') {
      // Bitirilen talepler (gelen) - sadece completed
      filtered = incomingRequests.filter(r => r.status === 'completed');
    } else if (taleplerSubTab === 'reddettigim') {
      // Reddettiğim talepler
      filtered = incomingRequests.filter(r => r.status === 'rejected_by_hr');
    } else if (taleplerSubTab === 'aktif') {
      // Aktif taleplerim (kendi)
      filtered = myRequests.filter(r => !['approved', 'completed', 'converted_to_job', 'rejected', 'rejected_by_branch', 'rejected_by_hr', 'rejected_by_accounting', 'rejected_by_purchasing'].includes(r.status));
    } else if (taleplerSubTab === 'onaylanan') {
      // Onaylanan taleplerim (kendi) - converted_to_job dahil
      filtered = myRequests.filter(r => r.status === 'approved' || r.status === 'converted_to_job');
    } else if (taleplerSubTab === 'benim_bitirilen') {
      // Bitirilen taleplerim (kendi) - sadece completed
      filtered = myRequests.filter(r => r.status === 'completed');
    } else if (taleplerSubTab === 'reddedilen') {
      // Reddedilen taleplerim (kendi)
      filtered = myRequests.filter(r => ['rejected', 'rejected_by_branch', 'rejected_by_hr', 'rejected_by_accounting', 'rejected_by_purchasing'].includes(r.status));
    } else {
      filtered = incomingRequests;
    }
    
    // Sıralama
    if (talepSortConfig.key && filtered) {
      return [...filtered].sort((a, b) => {
        let aVal = a[talepSortConfig.key] || '';
        let bVal = b[talepSortConfig.key] || '';
        if (talepSortConfig.key === 'created_at') {
          aVal = new Date(aVal).getTime();
          bVal = new Date(bVal).getTime();
        }
        if (aVal < bVal) return talepSortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return talepSortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }
    return filtered;
  };

  const handleTalepSort = (key) => {
    let direction = 'asc';
    if (talepSortConfig.key === key && talepSortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setTalepSortConfig({ key, direction });
  };

  const getTalepSortIcon = (key) => {
    if (talepSortConfig.key !== key) {
      return <ArrowUpDown className="h-4 w-4 text-gray-400" />;
    }
    return talepSortConfig.direction === 'asc' 
      ? <ArrowUp className="h-4 w-4 text-violet-600" />
      : <ArrowDown className="h-4 w-4 text-violet-600" />;
  };

  const loadHrUsers = async () => {
    try {
      const res = await axios.get(`${API}/hr/users`, { headers: getAuthHeaders() });
      setHrUsers(res.data || []);
    } catch (error) {
      console.error('Kullanıcılar yüklenirken hata:', error);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      tracking_users: [],
      company: '',
      start_date: new Date().toISOString().split('T')[0],
      estimated_end_date: '',
      locations: [''],
      description: '',
      status: 'active'
    });
    setPendingJobDocuments([]);
  };

  // İş belgelerini yükle
  const loadJobDocuments = async (jobId) => {
    setJobDocumentsLoading(true);
    try {
      const res = await axios.get(`${API}/hr/jobs/${jobId}/documents`, { headers: getAuthHeaders() });
      setJobDocuments(res.data || []);
    } catch (error) {
      console.error('İş belgeleri yüklenirken hata:', error);
    }
    setJobDocumentsLoading(false);
  };

  // Belge seçimi (form için)
  const handleJobDocumentSelect = (e) => {
    const files = Array.from(e.target.files);
    setPendingJobDocuments(prev => [...prev, ...files]);
  };

  // Bekleyen belgeyi kaldır
  const removePendingDocument = (index) => {
    setPendingJobDocuments(prev => prev.filter((_, i) => i !== index));
  };

  // Belgeleri yükle (iş oluşturulduktan sonra)
  const uploadJobDocuments = async (jobId) => {
    if (pendingJobDocuments.length === 0) return;
    
    for (const file of pendingJobDocuments) {
      try {
        const formDataUpload = new FormData();
        formDataUpload.append('file', file);
        formDataUpload.append('item_type', 'job');
        formDataUpload.append('item_id', jobId);
        formDataUpload.append('job_id', jobId);
        
        await axios.post(`${API}/upload/document`, formDataUpload, {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data'
          }
        });
      } catch (error) {
        console.error('Belge yüklenirken hata:', error);
        toast.error(`${file.name} yüklenemedi`);
      }
    }
  };

  // Belge indirme
  const downloadJobDocument = async (doc) => {
    try {
      const response = await axios.get(`${API}/documents/${doc.id}/download`, {
        headers: getAuthHeaders(),
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', doc.original_filename || doc.filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Belge indirme hatası:', error);
      toast.error('Belge indirilemedi');
    }
  };

  const handleCreateJob = async () => {
    if (!formData.name.trim()) {
      toast.error('İş adı gerekli');
      return;
    }
    if (!formData.company.trim()) {
      toast.error('Şirket adı gerekli');
      return;
    }
    if (!formData.start_date) {
      toast.error('Başlangıç tarihi gerekli');
      return;
    }
    if (!formData.estimated_end_date) {
      toast.error('Tahmini bitiş tarihi gerekli');
      return;
    }

    try {
      const payload = {
        ...formData,
        locations: formData.locations.filter(loc => loc.trim() !== '')
      };
      const response = await axios.post(`${API}/hr/jobs`, payload, { headers: getAuthHeaders() });
      const jobId = response.data.job_id;
      
      // Bekleyen belgeleri yükle
      if (pendingJobDocuments.length > 0 && jobId) {
        await uploadJobDocuments(jobId);
        toast.success(`İş oluşturuldu ve ${pendingJobDocuments.length} belge yüklendi`);
      } else {
        toast.success('İş oluşturuldu');
      }
      
      setCreateModalOpen(false);
      resetForm();
      loadJobs();
    } catch (error) {
      console.error('İş oluşturulurken hata:', error);
      toast.error('İş oluşturulamadı');
    }
  };

  const handleEditJob = async () => {
    if (!formData.name.trim()) {
      toast.error('İş adı gerekli');
      return;
    }

    try {
      const payload = {
        ...formData,
        locations: formData.locations.filter(loc => loc.trim() !== '')
      };
      await axios.put(`${API}/hr/jobs/${selectedJob.id}`, payload, { headers: getAuthHeaders() });
      toast.success('İş güncellendi');
      setEditModalOpen(false);
      resetForm();
      loadJobs();
    } catch (error) {
      console.error('İş güncellenirken hata:', error);
      toast.error('İş güncellenemedi');
    }
  };

  const handleArchiveJob = async () => {
    try {
      await axios.put(`${API}/hr/jobs/${selectedJob.id}/archive`, {}, { headers: getAuthHeaders() });
      toast.success('İş arşive gönderildi');
      setArchiveModalOpen(false);
      setSelectedJob(null);
      loadJobs();
      loadArchivedJobs();
      loadCompletedJobs();
      loadCancelledJobs();
    } catch (error) {
      console.error('İş arşivlenirken hata:', error);
      toast.error('İş arşivlenemedi');
    }
  };

  const handleRestoreJob = async (jobId) => {
    try {
      await axios.put(`${API}/hr/jobs/${jobId}/restore`, {}, { headers: getAuthHeaders() });
      toast.success('İş arşivden geri yüklendi');
      // Her iki listeyi de güncelle
      loadArchivedJobs();
      loadJobs();
    } catch (error) {
      console.error('İş geri yüklenirken hata:', error);
      toast.error('İş geri yüklenemedi');
    }
  };

  const handleCancelJob = async () => {
    if (!selectedJob || !cancellationReason.trim()) {
      toast.error('İptal açıklaması giriniz');
      return;
    }
    try {
      await axios.put(`${API}/hr/jobs/${selectedJob.id}/cancel`, { cancellation_reason: cancellationReason }, { headers: getAuthHeaders() });
      toast.success('İş iptal edildi');
      setCancelModalOpen(false);
      setDetailModalOpen(false);
      setCancellationReason('');
      setSelectedJob(null);
      loadJobs();
      loadArchivedJobs();
    } catch (error) {
      console.error('İş iptal edilirken hata:', error);
      toast.error('İş iptal edilemedi');
    }
  };

  const handleUpdateProgress = async () => {
    if (!selectedJob) return;
    
    try {
      await axios.put(`${API}/hr/jobs/${selectedJob.id}/progress?progress=${progressValue}`, {}, { headers: getAuthHeaders() });
      toast.success('İlerleme güncellendi');
      setProgressModalOpen(false);
      setDetailModalOpen(false);
      loadJobs();
    } catch (error) {
      console.error('İlerleme güncellenirken hata:', error);
      toast.error('İlerleme güncellenemedi');
    }
  };

  const openEditModal = (job) => {
    setSelectedJob(job);
    setFormData({
      name: job.name || '',
      tracking_users: job.tracking_users || [],
      company: job.company || '',
      start_date: job.start_date || '',
      estimated_end_date: job.estimated_end_date || '',
      locations: job.locations?.length > 0 ? job.locations : [''],
      description: job.description || '',
      status: job.status || 'active'
    });
    setEditModalOpen(true);
  };

  const openDetailModal = (job) => {
    setSelectedJob(job);
    setDetailModalOpen(true);
    loadJobDocuments(job.id);
  };

  const openArchiveModal = (job) => {
    setSelectedJob(job);
    setArchiveModalOpen(true);
  };

  const openProgressModal = (job) => {
    setSelectedJob(job);
    setProgressValue(job.progress || 0);
    setProgressModalOpen(true);
  };

  const handleUserToggle = (userId) => {
    setFormData(prev => {
      const users = prev.tracking_users || [];
      if (users.includes(userId)) {
        return { ...prev, tracking_users: users.filter(id => id !== userId) };
      } else {
        return { ...prev, tracking_users: [...users, userId] };
      }
    });
  };

  const addLocation = () => {
    setFormData(prev => ({
      ...prev,
      locations: [...prev.locations, '']
    }));
  };

  const removeLocation = (index) => {
    if (formData.locations.length > 1) {
      setFormData(prev => ({
        ...prev,
        locations: prev.locations.filter((_, i) => i !== index)
      }));
    }
  };

  const updateLocation = (index, value) => {
    setFormData(prev => ({
      ...prev,
      locations: prev.locations.map((loc, i) => i === index ? value : loc)
    }));
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'active':
        return <Badge className="bg-blue-100 text-blue-700 border-blue-200"><Clock className="h-3 w-3 mr-1" />Devam Ediyor</Badge>;
      case 'completed':
        return <Badge className="bg-green-100 text-green-700 border-green-200"><CheckCircle className="h-3 w-3 mr-1" />Tamamlandı</Badge>;
      case 'cancelled':
        return <Badge className="bg-red-100 text-red-700 border-red-200"><XCircle className="h-3 w-3 mr-1" />İptal Edildi</Badge>;
      default:
        return <Badge variant="outline">{status}</Badge>;
    }
  };

  const getProgressColor = (progress) => {
    if (progress >= 80) return 'bg-green-500';
    if (progress >= 50) return 'bg-violet-500';
    if (progress >= 25) return 'bg-orange-500';
    return 'bg-red-500';
  };

  // Sıralama fonksiyonları
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <ArrowUpDown className="h-4 w-4 text-gray-400" />;
    }
    return sortConfig.direction === 'asc' 
      ? <ArrowUp className="h-4 w-4 text-violet-600" />
      : <ArrowDown className="h-4 w-4 text-violet-600" />;
  };

  const sortedJobs = useMemo(() => {
    const jobsToSort = activeTab === 'archive' ? archivedJobs : jobs;
    if (!sortConfig.key) return jobsToSort;
    
    return [...jobsToSort].sort((a, b) => {
      let aVal, bVal;
      
      switch (sortConfig.key) {
        case 'name':
          aVal = a.name?.toLowerCase() || '';
          bVal = b.name?.toLowerCase() || '';
          break;
        case 'company':
          aVal = a.company?.toLowerCase() || '';
          bVal = b.company?.toLowerCase() || '';
          break;
        case 'start_date':
          aVal = new Date(a.start_date || 0).getTime();
          bVal = new Date(b.start_date || 0).getTime();
          break;
        case 'estimated_end_date':
          aVal = new Date(a.estimated_end_date || 0).getTime();
          bVal = new Date(b.estimated_end_date || 0).getTime();
          break;
        case 'progress':
          aVal = a.progress || 0;
          bVal = b.progress || 0;
          break;
        case 'status':
          const statusOrder = { active: 1, completed: 2, cancelled: 3 };
          aVal = statusOrder[a.status] || 0;
          bVal = statusOrder[b.status] || 0;
          break;
        case 'created_at':
          aVal = new Date(a.created_at || 0).getTime();
          bVal = new Date(b.created_at || 0).getTime();
          break;
        case 'archived_at':
          aVal = new Date(a.archived_at || 0).getTime();
          bVal = new Date(b.archived_at || 0).getTime();
          break;
        default:
          return 0;
      }
      
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [jobs, archivedJobs, sortConfig, activeTab]);

  const filteredJobs = useMemo(() => {
    let result = sortedJobs;
    // AKTİF İŞLER sekmesinde completed ve cancelled olanları gösterme
    if (activeTab === 'active') {
      result = result.filter(job => job.status !== 'completed' && job.status !== 'cancelled');
    }
    if (statusFilter !== 'all') {
      result = result.filter(job => job.status === statusFilter);
    }
    return result;
  }, [sortedJobs, statusFilter, activeTab]);

  // İşe bağlı öğeler için fonksiyonlar
  const openReportsModal = async (job) => {
    setSelectedJob(job);
    setReportsModalOpen(true);
    setItemLoading(true);
    try {
      const res = await axios.get(`${API}/hr/jobs/${job.id}/reports`, { headers: getAuthHeaders() });
      setJobReports(res.data || []);
      // Görüntüleme kaydı
      await axios.post(`${API}/hr/jobs/${job.id}/mark-viewed?item_type=reports`, {}, { headers: getAuthHeaders() });
      // İş listesini güncelle
      loadJobs();
    } catch (error) {
      console.error('Raporlar yüklenirken hata:', error);
      toast.error('Raporlar yüklenemedi');
    }
    setItemLoading(false);
  };

  const openSchedulesModal = async (job) => {
    setSelectedJob(job);
    setSchedulesModalOpen(true);
    setItemLoading(true);
    try {
      const res = await axios.get(`${API}/hr/jobs/${job.id}/schedules`, { headers: getAuthHeaders() });
      setJobSchedules(res.data || []);
      // Görüntüleme kaydı
      await axios.post(`${API}/hr/jobs/${job.id}/mark-viewed?item_type=schedules`, {}, { headers: getAuthHeaders() });
      loadJobs();
    } catch (error) {
      console.error('İş programları yüklenirken hata:', error);
      toast.error('İş programları yüklenemedi');
    }
    setItemLoading(false);
  };

  const openTasksModal = async (job) => {
    setSelectedJob(job);
    setTasksModalOpen(true);
    setItemLoading(true);
    try {
      const res = await axios.get(`${API}/hr/jobs/${job.id}/tasks`, { headers: getAuthHeaders() });
      setJobTasks(res.data || []);
      // Görüntüleme kaydı
      await axios.post(`${API}/hr/jobs/${job.id}/mark-viewed?item_type=tasks`, {}, { headers: getAuthHeaders() });
      loadJobs();
    } catch (error) {
      console.error('Görevler yüklenirken hata:', error);
      toast.error('Görevler yüklenemedi');
    }
    setItemLoading(false);
  };

  const handleAddReport = async () => {
    if (!newReport.title.trim()) {
      toast.error('Rapor başlığı gerekli');
      return;
    }
    try {
      const res = await axios.post(`${API}/hr/jobs/${selectedJob.id}/reports`, newReport, { headers: getAuthHeaders() });
      const reportId = res.data.report_id;
      
      if (selectedFiles.length > 0) {
        await uploadDocuments('report', reportId);
      }
      
      toast.success('Rapor eklendi');
      setAddReportOpen(false);
      setNewReport({ title: '', content: '', report_type: 'general' });
      setSelectedFiles([]);
      openReportsModal(selectedJob);
    } catch (error) {
      console.error('Rapor eklenirken hata:', error);
      toast.error('Rapor eklenemedi');
    }
  };

  const handleAddSchedule = async () => {
    if (!newSchedule.title.trim()) {
      toast.error('İş programı başlığı gerekli');
      return;
    }
    if (!newSchedule.scheduled_date) {
      toast.error('Tarih gerekli');
      return;
    }
    try {
      const res = await axios.post(`${API}/hr/jobs/${selectedJob.id}/schedules`, newSchedule, { headers: getAuthHeaders() });
      const scheduleId = res.data.schedule_id;
      
      if (selectedFiles.length > 0) {
        await uploadDocuments('schedule', scheduleId);
      }
      
      toast.success('İş programı eklendi');
      setAddScheduleOpen(false);
      setNewSchedule({ title: '', description: '', scheduled_date: '', scheduled_time: '' });
      setSelectedFiles([]);
      openSchedulesModal(selectedJob);
    } catch (error) {
      console.error('İş programı eklenirken hata:', error);
      toast.error('İş programı eklenemedi');
    }
  };

  const handleAddTask = async () => {
    if (!newTask.title.trim()) {
      toast.error('Görev başlığı gerekli');
      return;
    }
    try {
      const res = await axios.post(`${API}/hr/jobs/${selectedJob.id}/tasks`, newTask, { headers: getAuthHeaders() });
      const taskId = res.data.task_id;
      
      if (selectedFiles.length > 0) {
        await uploadDocuments('task', taskId);
      }
      
      toast.success('Görev eklendi');
      setAddTaskOpen(false);
      setNewTask({ title: '', description: '', assigned_to: '', due_date: '', priority: 'normal' });
      setSelectedFiles([]);
      openTasksModal(selectedJob);
    } catch (error) {
      console.error('Görev eklenirken hata:', error);
      toast.error('Görev eklenemedi');
    }
  };

  const handleDeleteReport = async (reportId) => {
    try {
      await axios.delete(`${API}/hr/jobs/${selectedJob.id}/reports/${reportId}`, { headers: getAuthHeaders() });
      toast.success('Rapor silindi');
      openReportsModal(selectedJob);
    } catch (error) {
      toast.error('Rapor silinemedi');
    }
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      await axios.delete(`${API}/hr/jobs/${selectedJob.id}/schedules/${scheduleId}`, { headers: getAuthHeaders() });
      toast.success('İş programı silindi');
      openSchedulesModal(selectedJob);
    } catch (error) {
      toast.error('İş programı silinemedi');
    }
  };

  const handleDeleteTask = async (taskId) => {
    try {
      await axios.delete(`${API}/hr/jobs/${selectedJob.id}/tasks/${taskId}`, { headers: getAuthHeaders() });
      toast.success('Görev silindi');
      openTasksModal(selectedJob);
    } catch (error) {
      toast.error('Görev silinemedi');
    }
  };

  // Belge yükleme fonksiyonları
  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(prev => [...prev, ...files]);
  };

  const removeSelectedFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };

  const uploadDocuments = async (itemType, itemId) => {
    if (selectedFiles.length === 0) return [];
    
    setUploadingFiles(true);
    const uploadedDocs = [];
    
    for (const file of selectedFiles) {
      try {
        const formDataUpload = new FormData();
        formDataUpload.append('file', file);
        formDataUpload.append('item_type', itemType);
        formDataUpload.append('item_id', itemId);
        formDataUpload.append('job_id', selectedJob.id);
        
        const res = await axios.post(`${API}/upload/document`, formDataUpload, {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data'
          }
        });
        uploadedDocs.push(res.data);
      } catch (error) {
        console.error('Belge yüklenirken hata:', error);
        toast.error(`${file.name} yüklenemedi`);
      }
    }
    
    setUploadingFiles(false);
    setSelectedFiles([]);
    return uploadedDocs;
  };

  const loadDocuments = async (itemType, itemId) => {
    try {
      const res = await axios.get(`${API}/hr/jobs/${selectedJob.id}/documents`, {
        params: { item_type: itemType, item_id: itemId },
        headers: getAuthHeaders()
      });
      return res.data || [];
    } catch (error) {
      console.error('Belgeler yüklenirken hata:', error);
      return [];
    }
  };

  const handlePreviewDocument = async (doc) => {
    const previewableTypes = ['.pdf', '.png', '.jpg', '.jpeg', '.gif'];
    if (previewableTypes.includes(doc.file_extension)) {
      setPreviewDoc(doc);
      setPreviewModalOpen(true);
    } else {
      handleDownloadDocument(doc);
    }
  };

  const handleDownloadDocument = async (doc) => {
    try {
      const response = await axios.get(`${API}/documents/${doc.id}/download`, {
        headers: getAuthHeaders(),
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', doc.original_filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error('Belge indirilemedi');
    }
  };

  const handleDeleteDocument = async (docId, itemType, refreshCallback) => {
    try {
      await axios.delete(`${API}/documents/${docId}`, { headers: getAuthHeaders() });
      toast.success('Belge silindi');
      if (refreshCallback) refreshCallback();
    } catch (error) {
      toast.error('Belge silinemedi');
    }
  };

  const getFileIcon = (extension) => {
    const imageTypes = ['.png', '.jpg', '.jpeg', '.gif'];
    if (imageTypes.includes(extension)) {
      return <Image className="h-4 w-4 text-green-600" />;
    }
    if (extension === '.pdf') {
      return <FileText className="h-4 w-4 text-red-600" />;
    }
    return <File className="h-4 w-4 text-blue-600" />;
  };

  // Detay görüntüleme fonksiyonları
  const viewReportDetail = async (report) => {
    setSelectedReport(report);
    setReportDetailModal(true);
    try {
      const docs = await loadDocuments('report', report.id);
      setItemDocuments(docs);
    } catch (error) {
      setItemDocuments([]);
    }
  };

  const viewScheduleDetail = async (schedule) => {
    setSelectedSchedule(schedule);
    setScheduleDetailModal(true);
    try {
      // İş programı detayını API'dan al (güncellemeler dahil)
      const res = await axios.get(`${API}/hr/jobs/${selectedJob.id}/schedules/${schedule.id}`, { headers: getAuthHeaders() });
      setSelectedSchedule(res.data);
      const docs = await loadDocuments('schedule', schedule.id);
      setItemDocuments(docs);
    } catch (error) {
      setItemDocuments([]);
    }
  };

  // İş programını tamamla
  const handleCompleteSchedule = async () => {
    if (!selectedSchedule || !selectedJob) return;
    
    setCompletingSchedule(true);
    try {
      await axios.put(`${API}/hr/jobs/${selectedJob.id}/schedules/${selectedSchedule.id}/complete`, {}, { headers: getAuthHeaders() });
      toast.success('İş programı tamamlandı');
      setScheduleDetailModal(false);
      openSchedulesModal(selectedJob);
    } catch (error) {
      console.error('İş programı tamamlama hatası:', error);
      toast.error('İş programı tamamlanamadı');
    }
    setCompletingSchedule(false);
  };

  // İş programı güncelleme modalını aç
  const openScheduleUpdateModal = () => {
    setScheduleUpdateText('');
    setScheduleUpdateFiles([]);
    setScheduleUpdateModal(true);
  };

  // İş programı güncelleme dosya seçimi
  const handleScheduleUpdateFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setScheduleUpdateFiles(prev => [...prev, ...files]);
  };

  // İş programı güncelleme dosyasını kaldır
  const removeScheduleUpdateFile = (index) => {
    setScheduleUpdateFiles(prev => prev.filter((_, i) => i !== index));
  };

  // İş programı güncellemesi gönder
  const handleSubmitScheduleUpdate = async () => {
    if (!scheduleUpdateText.trim()) {
      toast.error('Güncelleme açıklaması gerekli');
      return;
    }
    
    setSubmittingScheduleUpdate(true);
    try {
      // Güncelleme metnini gönder
      await axios.post(
        `${API}/hr/jobs/${selectedJob.id}/schedules/${selectedSchedule.id}/updates`,
        { description: scheduleUpdateText },
        { headers: getAuthHeaders() }
      );
      
      // Belgeleri yükle
      for (const file of scheduleUpdateFiles) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('job_id', selectedJob.id);
        formData.append('item_type', 'schedule');
        formData.append('item_id', selectedSchedule.id);
        
        await axios.post(`${API}/upload/document`, formData, {
          headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
        });
      }
      
      toast.success('Güncelleme eklendi');
      setScheduleUpdateModal(false);
      
      // İş programı detayını yenile
      const res = await axios.get(`${API}/hr/jobs/${selectedJob.id}/schedules/${selectedSchedule.id}`, { headers: getAuthHeaders() });
      setSelectedSchedule(res.data);
      const docs = await loadDocuments('schedule', selectedSchedule.id);
      setItemDocuments(docs);
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      toast.error('Güncelleme eklenemedi');
    }
    setSubmittingScheduleUpdate(false);
  };

  const viewTaskDetail = async (task) => {
    setSelectedTask(task);
    setTaskDetailModal(true);
    try {
      // Görev detayını API'dan al (güncellemeler dahil)
      const res = await axios.get(`${API}/hr/jobs/${selectedJob.id}/tasks/${task.id}`, { headers: getAuthHeaders() });
      setSelectedTask(res.data);
      const docs = await loadDocuments('task', task.id);
      setItemDocuments(docs);
    } catch (error) {
      setItemDocuments([]);
    }
  };

  // Görevi tamamla
  const handleCompleteTask = async () => {
    if (!selectedTask || !selectedJob) return;
    
    setCompletingTask(true);
    try {
      await axios.put(`${API}/hr/jobs/${selectedJob.id}/tasks/${selectedTask.id}/complete`, {}, { headers: getAuthHeaders() });
      toast.success('Görev tamamlandı');
      setTaskDetailModal(false);
      openTasksModal(selectedJob);
    } catch (error) {
      console.error('Görev tamamlama hatası:', error);
      toast.error('Görev tamamlanamadı');
    }
    setCompletingTask(false);
  };

  // Görev güncelleme modalını aç
  const openTaskUpdateModal = () => {
    setTaskUpdateText('');
    setTaskUpdateFiles([]);
    setTaskUpdateModal(true);
  };

  // Görev güncelleme dosya seçimi
  const handleTaskUpdateFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setTaskUpdateFiles(prev => [...prev, ...files]);
  };

  // Görev güncelleme dosyasını kaldır
  const removeTaskUpdateFile = (index) => {
    setTaskUpdateFiles(prev => prev.filter((_, i) => i !== index));
  };

  // Görev güncellemesi gönder
  const handleSubmitTaskUpdate = async () => {
    if (!taskUpdateText.trim()) {
      toast.error('Güncelleme açıklaması gerekli');
      return;
    }
    
    setSubmittingTaskUpdate(true);
    try {
      // Güncelleme metnini gönder
      await axios.post(
        `${API}/hr/jobs/${selectedJob.id}/tasks/${selectedTask.id}/updates`,
        { description: taskUpdateText },
        { headers: getAuthHeaders() }
      );
      
      // Belgeleri yükle
      for (const file of taskUpdateFiles) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('job_id', selectedJob.id);
        formData.append('item_type', 'task');
        formData.append('item_id', selectedTask.id);
        
        await axios.post(`${API}/upload/document`, formData, {
          headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
        });
      }
      
      toast.success('Güncelleme eklendi');
      setTaskUpdateModal(false);
      
      // Görev detayını yenile
      const res = await axios.get(`${API}/hr/jobs/${selectedJob.id}/tasks/${selectedTask.id}`, { headers: getAuthHeaders() });
      setSelectedTask(res.data);
      const docs = await loadDocuments('task', selectedTask.id);
      setItemDocuments(docs);
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      toast.error('Güncelleme eklenemedi');
    }
    setSubmittingTaskUpdate(false);
  };

  // Belge yükleme bileşeni
  const DocumentUploader = ({ inputId = 'file-upload' }) => (
    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-violet-500 transition-colors">
      <input
        type="file"
        multiple
        onChange={handleFileSelect}
        className="hidden"
        id={inputId}
        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.png,.jpg,.jpeg,.gif,.zip,.rar"
      />
      <label htmlFor={inputId} className="cursor-pointer">
        <Upload className="h-8 w-8 mx-auto text-gray-400 mb-2" />
        <p className="text-sm text-gray-600">Belge yüklemek için tıklayın</p>
        <p className="text-xs text-gray-400 mt-1">PDF, Word, Excel, Resim (max 10MB)</p>
      </label>
    </div>
  );

  // Seçili dosyalar listesi
  const SelectedFilesList = () => (
    selectedFiles.length > 0 && (
      <div className="mt-3 space-y-2">
        <Label className="text-sm text-gray-600">Seçili Belgeler:</Label>
        {selectedFiles.map((file, index) => (
          <div key={index} className="flex items-center justify-between bg-gray-50 p-2 rounded">
            <div className="flex items-center gap-2">
              {getFileIcon(`.${file.name.split('.').pop()}`)}
              <span className="text-sm truncate max-w-[200px]">{file.name}</span>
              <span className="text-xs text-gray-400">({(file.size / 1024).toFixed(1)} KB)</span>
            </div>
            <Button size="sm" variant="ghost" onClick={() => removeSelectedFile(index)}>
              <X className="h-4 w-4 text-red-500" />
            </Button>
          </div>
        ))}
      </div>
    )
  );

  // Belge listesi bileşeni
  const DocumentsList = ({ documents, onDelete, onRefresh }) => (
    documents && documents.length > 0 && (
      <div className="mt-4 border-t pt-4">
        <Label className="text-sm font-medium flex items-center gap-2 mb-2">
          <FileIcon className="h-4 w-4" />
          Ekli Belgeler ({documents.length})
        </Label>
        <div className="space-y-2">
          {documents.map((doc) => (
            <div key={doc.id} className="flex items-center justify-between bg-gray-50 p-2 rounded">
              <div className="flex items-center gap-2">
                {getFileIcon(doc.file_extension)}
                <span className="text-sm truncate max-w-[200px]">{doc.original_filename}</span>
                <span className="text-xs text-gray-400">({(doc.file_size / 1024).toFixed(1)} KB)</span>
              </div>
              <div className="flex gap-1">
                <Button size="sm" variant="ghost" onClick={() => handlePreviewDocument(doc)} title="Önizle">
                  <Eye className="h-4 w-4 text-blue-600" />
                </Button>
                <Button size="sm" variant="ghost" onClick={() => handleDownloadDocument(doc)} title="İndir">
                  <Download className="h-4 w-4 text-green-600" />
                </Button>
                <Button size="sm" variant="ghost" onClick={() => handleDeleteDocument(doc.id, doc.item_type, onRefresh)} title="Sil">
                  <Trash2 className="h-4 w-4 text-red-600" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );

  const getPriorityBadge = (priority) => {
    switch (priority) {
      case 'high':
        return <Badge className="bg-red-100 text-red-700">Yüksek</Badge>;
      case 'normal':
        return <Badge className="bg-blue-100 text-blue-700">Normal</Badge>;
      case 'low':
        return <Badge className="bg-gray-100 text-gray-700">Düşük</Badge>;
      default:
        return <Badge variant="outline">{priority}</Badge>;
    }
  };

  const getTaskStatusBadge = (status) => {
    switch (status) {
      case 'pending':
        return <Badge className="bg-yellow-100 text-yellow-700">Bekliyor</Badge>;
      case 'in_progress':
        return <Badge className="bg-blue-100 text-blue-700">Devam Ediyor</Badge>;
      case 'completed':
        return <Badge className="bg-green-100 text-green-700">Tamamlandı</Badge>;
      default:
        return <Badge variant="outline">{status}</Badge>;
    }
  };

  // Form content renderer
  const renderFormContent = (isEdit) => (
    <div className="space-y-4 py-4">
      {/* İşin Adı */}
      <div className="space-y-2">
        <Label>İşin Adı *</Label>
        <Input 
          value={formData.name} 
          onChange={(e) => setFormData(prev => ({...prev, name: e.target.value}))} 
          placeholder="İş adını girin"
          data-testid="job-name-input"
        />
      </div>

      {/* İşi Takip Eden Kişiler */}
      <div className="space-y-2">
        <Label className="flex items-center gap-2">
          <Users className="h-4 w-4" />
          İşi Takip Eden Kişiler
        </Label>
        <div className="border rounded-md p-3 max-h-40 overflow-y-auto space-y-2" data-testid="tracking-users-list">
          {hrUsers.length === 0 ? (
            <p className="text-sm text-gray-500">Kullanıcı bulunamadı</p>
          ) : (
            hrUsers.map(user => (
              <div key={user.id} className="flex items-center space-x-2">
                <Checkbox
                  id={`user-${user.id}-${isEdit ? 'edit' : 'create'}`}
                  checked={formData.tracking_users.includes(user.id)}
                  onCheckedChange={() => handleUserToggle(user.id)}
                />
                <label htmlFor={`user-${user.id}-${isEdit ? 'edit' : 'create'}`} className="text-sm cursor-pointer">
                  {user.name}
                </label>
              </div>
            ))
          )}
        </div>
        {formData.tracking_users.length > 0 && (
          <p className="text-xs text-gray-500">{formData.tracking_users.length} kişi seçildi</p>
        )}
      </div>

      {/* İşi Yapan Şirket */}
      <div className="space-y-2">
        <Label className="flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          İşi Yapan Şirket *
        </Label>
        <Input 
          value={formData.company} 
          onChange={(e) => setFormData(prev => ({...prev, company: e.target.value}))} 
          placeholder="Şirket adını girin"
          data-testid="job-company-input"
        />
      </div>

      {/* Tarihler */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <Calendar className="h-4 w-4" />
            Başlangıç Tarihi *
          </Label>
          <Input 
            type="date" 
            value={formData.start_date} 
            onChange={(e) => setFormData(prev => ({...prev, start_date: e.target.value}))}
            data-testid="job-start-date-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <Calendar className="h-4 w-4" />
            Tahmini Bitiş Tarihi *
          </Label>
          <Input 
            type="date" 
            value={formData.estimated_end_date} 
            onChange={(e) => setFormData(prev => ({...prev, estimated_end_date: e.target.value}))}
            data-testid="job-end-date-input"
          />
        </div>
      </div>

      {/* Konumlar */}
      <div className="space-y-2">
        <Label className="flex items-center gap-2">
          <MapPin className="h-4 w-4" />
          Konum(lar)
        </Label>
        <div className="space-y-2">
          {formData.locations.map((location, index) => (
            <div key={index} className="flex items-center gap-2">
              <Input
                value={location}
                onChange={(e) => updateLocation(index, e.target.value)}
                placeholder={`Konum ${index + 1}`}
                data-testid={`job-location-input-${index}`}
              />
              {formData.locations.length > 1 && (
                <Button 
                  type="button" 
                  variant="outline" 
                  size="icon"
                  onClick={() => removeLocation(index)}
                >
                  <X className="h-4 w-4" />
                </Button>
              )}
            </div>
          ))}
          <Button 
            type="button" 
            variant="outline" 
            size="sm" 
            onClick={addLocation}
            className="mt-2"
          >
            <Plus className="h-4 w-4 mr-1" />
            Konum Ekle
          </Button>
        </div>
      </div>

      {/* Açıklama */}
      <div className="space-y-2">
        <Label>Açıklama</Label>
        <Textarea 
          value={formData.description} 
          onChange={(e) => setFormData(prev => ({...prev, description: e.target.value}))} 
          placeholder="İş hakkında açıklama..."
          rows={3}
          data-testid="job-description-input"
        />
      </div>

      {/* İş ile Alakalı Belgeler (sadece oluşturma modunda) */}
      {!isEdit && (
        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <File className="h-4 w-4" />
            İş ile Alakalı Belgeler
          </Label>
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
            <input
              type="file"
              multiple
              onChange={handleJobDocumentSelect}
              className="hidden"
              id="job-document-upload"
              data-testid="job-document-input"
            />
            <label 
              htmlFor="job-document-upload" 
              className="flex flex-col items-center cursor-pointer"
            >
              <Upload className="h-8 w-8 text-gray-400 mb-2" />
              <span className="text-sm text-gray-600">Belge yüklemek için tıklayın</span>
              <span className="text-xs text-gray-400 mt-1">PDF, Word, Excel, resim dosyaları</span>
            </label>
          </div>
          
          {/* Seçilen belgeler listesi */}
          {pendingJobDocuments.length > 0 && (
            <div className="space-y-2 mt-3">
              <p className="text-sm font-medium text-gray-700">{pendingJobDocuments.length} belge seçildi:</p>
              {pendingJobDocuments.map((file, index) => (
                <div key={index} className="flex items-center justify-between bg-gray-50 p-2 rounded-md">
                  <div className="flex items-center gap-2">
                    <FileIcon className="h-4 w-4 text-violet-600" />
                    <span className="text-sm truncate max-w-[200px]">{file.name}</span>
                    <span className="text-xs text-gray-400">({(file.size / 1024).toFixed(1)} KB)</span>
                  </div>
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    onClick={() => removePendingDocument(index)}
                    className="h-6 w-6 p-0 text-red-500 hover:text-red-700"
                  >
                    <X className="h-4 w-4" />
                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Durum (sadece düzenleme modunda) */}
      {isEdit && (
        <div className="space-y-2">
          <Label>Durum</Label>
          <Select value={formData.status} onValueChange={(value) => setFormData(prev => ({...prev, status: value}))}>
            <SelectTrigger data-testid="job-status-select">
              <SelectValue placeholder="Durum seçin" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="active">Devam Ediyor</SelectItem>
              <SelectItem value="completed">Tamamlandı</SelectItem>
              <SelectItem value="cancelled">İptal Edildi</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );

  // Tablo render
  const renderJobsTable = (jobsList, isArchive = false) => {
    if (jobsList.length === 0) {
      return (
        <div className="text-center py-12 text-gray-500">
          {isArchive ? (
            <>
              <Archive className="h-16 w-16 mx-auto mb-4 opacity-50" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">Arşivde iş bulunmuyor</h3>
              <p className="text-gray-500">Arşivlenen işler burada görünecek</p>
            </>
          ) : (
            <>
              <Briefcase className="h-16 w-16 mx-auto mb-4 opacity-50" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">Henüz iş bulunmuyor</h3>
              <p className="text-gray-500 mb-4">İlk işi eklemek için yukarıdaki butonu kullanın</p>
            </>
          )}
        </div>
      );
    }

    return (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="cursor-pointer hover:bg-gray-50" onClick={() => handleSort('job_code')} data-testid="sort-job-code">
              <div className="flex items-center gap-2">İş No {getSortIcon('job_code')}</div>
            </TableHead>
            <TableHead className="cursor-pointer hover:bg-gray-50" onClick={() => handleSort('name')} data-testid="sort-name">
              <div className="flex items-center gap-2">İş Adı {getSortIcon('name')}</div>
            </TableHead>
            <TableHead className="cursor-pointer hover:bg-gray-50" onClick={() => handleSort('company')} data-testid="sort-company">
              <div className="flex items-center gap-2">Şirket {getSortIcon('company')}</div>
            </TableHead>
            <TableHead>İşi Veren</TableHead>
            <TableHead>Takip Edenler</TableHead>
            <TableHead className="cursor-pointer hover:bg-gray-50" onClick={() => handleSort('start_date')} data-testid="sort-start">
              <div className="flex items-center gap-2">Başlangıç {getSortIcon('start_date')}</div>
            </TableHead>
            <TableHead className="cursor-pointer hover:bg-gray-50" onClick={() => handleSort('estimated_end_date')} data-testid="sort-end">
              <div className="flex items-center gap-2">Tahmini Bitiş {getSortIcon('estimated_end_date')}</div>
            </TableHead>
            <TableHead>Konum(lar)</TableHead>
            <TableHead className="cursor-pointer hover:bg-gray-50" onClick={() => handleSort('progress')} data-testid="sort-progress">
              <div className="flex items-center gap-2">İş İlerleme {getSortIcon('progress')}</div>
            </TableHead>
            <TableHead className="cursor-pointer hover:bg-gray-50" onClick={() => handleSort('status')} data-testid="sort-status">
              <div className="flex items-center gap-2">Durum {getSortIcon('status')}</div>
            </TableHead>
            {isArchive && (
              <TableHead className="cursor-pointer hover:bg-gray-50" onClick={() => handleSort('archived_at')} data-testid="sort-archived">
                <div className="flex items-center gap-2">Arşivlenme {getSortIcon('archived_at')}</div>
              </TableHead>
            )}
            <TableHead>İşlemler</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {jobsList.map(job => (
            <TableRow key={job.id} data-testid={`job-row-${job.id}`}>
              <TableCell>
                <Badge variant="secondary" className="font-mono font-bold text-sm" data-testid={`job-code-${job.id}`}>
                  {job.job_code || '-'}
                </Badge>
              </TableCell>
              <TableCell className="font-medium">{job.name}</TableCell>
              <TableCell>
                <div className="flex items-center gap-1">
                  <Building2 className="h-4 w-4 text-gray-400" />
                  {job.company}
                </div>
              </TableCell>
              <TableCell data-testid={`job-creator-${job.id}`}>
                <span className="text-sm">{job.created_by_name || job.creator_name || '-'}</span>
              </TableCell>
              <TableCell>
                <div className="flex flex-wrap gap-1">
                  {job.tracking_user_details?.length > 0 ? (
                    job.tracking_user_details.slice(0, 2).map((user, idx) => (
                      <Badge key={idx} variant="outline" className="text-xs">
                        {user.name}
                      </Badge>
                    ))
                  ) : (
                    <span className="text-gray-400 text-sm">-</span>
                  )}
                  {job.tracking_user_details?.length > 2 && (
                    <Badge variant="outline" className="text-xs">
                      +{job.tracking_user_details.length - 2}
                    </Badge>
                  )}
                </div>
              </TableCell>
              <TableCell>{job.start_date}</TableCell>
              <TableCell>{job.estimated_end_date}</TableCell>
              <TableCell>
                <div className="flex flex-wrap gap-1">
                  {job.locations?.length > 0 ? (
                    job.locations.slice(0, 2).map((loc, idx) => (
                      <Badge key={idx} variant="secondary" className="text-xs">
                        <MapPin className="h-3 w-3 mr-1" />
                        {loc}
                      </Badge>
                    ))
                  ) : (
                    <span className="text-gray-400 text-sm">-</span>
                  )}
                  {job.locations?.length > 2 && (
                    <Badge variant="secondary" className="text-xs">
                      +{job.locations.length - 2}
                    </Badge>
                  )}
                </div>
              </TableCell>
              <TableCell>
                <div className="w-24">
                  <div className="flex items-center gap-2 mb-1">
                    <Percent className="h-3 w-3 text-gray-500" />
                    <span className="text-sm font-medium">{job.progress || 0}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className={`h-2 rounded-full ${getProgressColor(job.progress || 0)}`}
                      style={{ width: `${job.progress || 0}%` }}
                    />
                  </div>
                </div>
              </TableCell>
              <TableCell>{getStatusBadge(job.status)}</TableCell>
              {isArchive && (
                <TableCell>
                  <div className="text-sm text-gray-600">
                    {job.archived_at ? new Date(job.archived_at).toLocaleDateString('tr-TR') : '-'}
                    {job.archived_by_name && (
                      <div className="text-xs text-gray-400">{job.archived_by_name}</div>
                    )}
                  </div>
                </TableCell>
              )}
              <TableCell>
                <TooltipProvider>
                  <div className="flex gap-1">
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button 
                          size="sm" 
                          variant="outline" 
                          onClick={() => openDetailModal(job)}
                          data-testid={`view-job-${job.id}`}
                        >
                          <Eye className="h-4 w-4" />
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>Detay</TooltipContent>
                    </Tooltip>
                    
                    {!isArchive && job.status !== 'completed' && job.status !== 'cancelled' && (
                      <>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <Button 
                              size="sm" 
                              variant="outline"
                              className="text-purple-600 hover:text-purple-700 relative"
                              onClick={() => openReportsModal(job)}
                              data-testid={`reports-job-${job.id}`}
                            >
                              <FileText className="h-4 w-4" />
                              {job.new_reports_count > 0 && (
                                <span className="absolute -top-1 -right-1 bg-purple-600 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
                                  {job.new_reports_count}
                                </span>
                              )}
                            </Button>
                          </TooltipTrigger>
                          <TooltipContent>Raporlar ({job.reports_count || 0}){job.new_reports_count > 0 && ` - ${job.new_reports_count} yeni`}</TooltipContent>
                        </Tooltip>
                        
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <Button 
                              size="sm" 
                              variant="outline"
                              className="text-blue-600 hover:text-blue-700 relative"
                              onClick={() => openSchedulesModal(job)}
                              data-testid={`schedules-job-${job.id}`}
                            >
                              <CalendarDays className="h-4 w-4" />
                              {job.new_schedules_count > 0 && (
                                <span className="absolute -top-1 -right-1 bg-blue-600 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
                                  {job.new_schedules_count}
                                </span>
                              )}
                            </Button>
                          </TooltipTrigger>
                          <TooltipContent>İş Programı ({job.schedules_count || 0}){job.new_schedules_count > 0 && ` - ${job.new_schedules_count} yeni`}</TooltipContent>
                        </Tooltip>
                        
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <Button 
                              size="sm" 
                              variant="outline"
                              className="text-green-600 hover:text-green-700 relative"
                              onClick={() => openTasksModal(job)}
                              data-testid={`tasks-job-${job.id}`}
                            >
                              <ClipboardList className="h-4 w-4" />
                              {job.new_tasks_count > 0 && (
                                <span className="absolute -top-1 -right-1 bg-green-600 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
                                  {job.new_tasks_count}
                                </span>
                              )}
                            </Button>
                          </TooltipTrigger>
                          <TooltipContent>Görevler ({job.tasks_count || 0}){job.new_tasks_count > 0 && ` - ${job.new_tasks_count} yeni`}</TooltipContent>
                        </Tooltip>
                        
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <Button 
                              size="sm" 
                              variant="outline" 
                              onClick={() => openEditModal(job)}
                              data-testid={`edit-job-${job.id}`}
                            >
                              <Edit className="h-4 w-4" />
                            </Button>
                          </TooltipTrigger>
                          <TooltipContent>Düzenle</TooltipContent>
                        </Tooltip>
                        
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <Button 
                              size="sm" 
                              variant="outline" 
                              className="text-orange-600"
                              onClick={() => openArchiveModal(job)}
                              data-testid={`archive-job-${job.id}`}
                            >
                              <Archive className="h-4 w-4" />
                            </Button>
                          </TooltipTrigger>
                          <TooltipContent>Arşive Gönder</TooltipContent>
                        </Tooltip>
                      </>
                    )}

                    {(job.status === 'completed' || job.status === 'cancelled') && (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button 
                            size="sm" 
                            variant="outline" 
                            className="text-orange-600"
                            onClick={() => openArchiveModal(job)}
                            data-testid={`archive-job-${job.id}`}
                          >
                            <Archive className="h-4 w-4" />
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent>Arşive Gönder</TooltipContent>
                      </Tooltip>
                    )}
                    
                    {isArchive && job.status !== 'completed' && job.status !== 'cancelled' && (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button 
                            size="sm" 
                            variant="outline"
                            className="text-green-600 hover:text-green-700"
                            onClick={() => handleRestoreJob(job.id)}
                            data-testid={`restore-job-${job.id}`}
                          >
                            <RotateCcw className="h-4 w-4" />
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent>Geri Yükle</TooltipContent>
                      </Tooltip>
                    )}
                  </div>
                </TooltipProvider>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  return (
    <div className="space-y-6" data-testid="branch-jobs-page">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Briefcase className="h-8 w-8 text-violet-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900">İşler</h1>
            <p className="text-gray-500">İK işlerini yönetin</p>
          </div>
        </div>
        {activeTab === 'active' && (
          <Button 
            onClick={() => { resetForm(); setCreateModalOpen(true); }} 
            className="bg-violet-600 hover:bg-violet-700 gap-2"
            data-testid="add-job-btn"
          >
            <Plus className="h-4 w-4" />
            İŞ EKLE
          </Button>
        )}
        {activeTab === 'talepler' && (
          <Button 
            onClick={() => { resetForm(); setCreateModalOpen(true); }} 
            className="bg-indigo-600 hover:bg-indigo-700 gap-2"
            data-testid="add-talep-btn"
          >
            <Plus className="h-4 w-4" />
            TALEP EKLE
          </Button>
        )}
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-4 max-w-2xl">
          <TabsTrigger value="active" className="gap-2" data-testid="tab-active">
            <Briefcase className="h-4 w-4" />
            AKTİF İŞLER
          </TabsTrigger>
          <TabsTrigger value="archive" className="gap-2" data-testid="tab-archive">
            <Archive className="h-4 w-4" />
            ARŞİV
          </TabsTrigger>
          <TabsTrigger value="cancelled" className="gap-2" data-testid="tab-cancelled">
            <XCircle className="h-4 w-4" />
            İPTAL EDİLENLER
          </TabsTrigger>
          <TabsTrigger value="completed" className="gap-2" data-testid="tab-completed">
            <CheckCircle className="h-4 w-4" />
            TAMAMLANANLAR
          </TabsTrigger>
        </TabsList>

        <TabsContent value="active">
          {/* Filtreler */}
          <Card className="mt-4">
            <CardContent className="py-4">
              <div className="flex items-center gap-4">
                <Label>Durum Filtresi:</Label>
                <Select value={statusFilter} onValueChange={setStatusFilter}>
                  <SelectTrigger className="w-48" data-testid="status-filter">
                    <SelectValue placeholder="Tümü" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tümü</SelectItem>
                    <SelectItem value="active">Devam Ediyor</SelectItem>
                    <SelectItem value="completed">Tamamlandı</SelectItem>
                    <SelectItem value="cancelled">İptal Edildi</SelectItem>
                  </SelectContent>
                </Select>
                <Badge variant="outline" className="ml-auto">
                  {filteredJobs.length} iş
                </Badge>
              </div>
            </CardContent>
          </Card>

          {/* İşler Tablosu */}
          <Card className="mt-4">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Briefcase className="h-5 w-5 text-violet-600" />
                İş Listesi
              </CardTitle>
            </CardHeader>
            <CardContent>
              {loading ? (
                <div className="flex justify-center py-12">
                  <Loader2 className="h-8 w-8 animate-spin text-violet-600" />
                </div>
              ) : (
                renderJobsTable(filteredJobs, false)
              )}
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="archive">
          <Card className="mt-4">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Archive className="h-5 w-5 text-gray-600" />
                Arşivlenmiş İşler
              </CardTitle>
            </CardHeader>
            <CardContent>
              {loading ? (
                <div className="flex justify-center py-12">
                  <Loader2 className="h-8 w-8 animate-spin text-gray-600" />
                </div>
              ) : (
                renderJobsTable(archivedJobs, true)
              )}
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="cancelled">
          <Card className="mt-4">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <XCircle className="h-5 w-5 text-red-600" />
                İptal Edilen İşler
              </CardTitle>
            </CardHeader>
            <CardContent>
              {loading ? (
                <div className="flex justify-center py-12">
                  <Loader2 className="h-8 w-8 animate-spin text-gray-600" />
                </div>
              ) : cancelledJobs.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  <XCircle className="h-16 w-16 mx-auto mb-4 opacity-50" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">İptal edilmiş iş bulunmuyor</h3>
                </div>
              ) : (
                renderJobsTable(cancelledJobs, true)
              )}
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="completed">
          <Card className="mt-4">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-green-600" />
                Tamamlanan İşler
              </CardTitle>
            </CardHeader>
            <CardContent>
              {loading ? (
                <div className="flex justify-center py-12">
                  <Loader2 className="h-8 w-8 animate-spin text-gray-600" />
                </div>
              ) : completedJobs.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  <CheckCircle className="h-16 w-16 mx-auto mb-4 opacity-50" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Tamamlanmış iş bulunmuyor</h3>
                </div>
              ) : (
                renderJobsTable(completedJobs, true)
              )}
            </CardContent>
          </Card>
        </TabsContent>

      </Tabs>

      {/* Talep Detay Modal */}
      <Dialog open={!!selectedTalep} onOpenChange={() => { setSelectedTalep(null); setTalepActionNote(''); }}>
        <DialogContent className="sm:max-w-[600px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-indigo-600">
              <Eye className="h-5 w-5" />
              Talep Detayı
            </DialogTitle>
          </DialogHeader>
          {selectedTalep && (
            <div className="space-y-4 py-4 max-h-[60vh] overflow-y-auto">
              {selectedTalep.request_number && (
                <div className="p-3 bg-indigo-50 rounded-lg border border-indigo-200">
                  <div className="flex items-center gap-2">
                    <FileText className="h-4 w-4 text-indigo-600" />
                    <span className="text-sm text-indigo-700 font-medium">Talep No:</span>
                    <span className="text-sm text-indigo-900 font-mono">{selectedTalep.request_number}</span>
                  </div>
                </div>
              )}
              
              {selectedTalep.owner_name && (
                <div className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center gap-2">
                    <Users className="h-4 w-4 text-gray-600" />
                    <span className="text-sm text-gray-700 font-medium">Gönderen:</span>
                    <span className="text-sm text-gray-900">{selectedTalep.owner_name}</span>
                  </div>
                </div>
              )}
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500 text-xs">Başlık</Label>
                  <p className="font-medium">{selectedTalep.title}</p>
                </div>
                <div>
                  <Label className="text-gray-500 text-xs">Kategori</Label>
                  <p className="font-medium">{selectedTalep.category}</p>
                </div>
                <div>
                  <Label className="text-gray-500 text-xs">Tarih</Label>
                  <p className="font-medium">
                    {new Date(selectedTalep.created_at).toLocaleDateString('tr-TR')}
                    <span className="text-gray-500 text-sm ml-2">
                      {new Date(selectedTalep.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </p>
                </div>
                <div>
                  <Label className="text-gray-500 text-xs">Durum</Label>
                  <Badge className={
                    selectedTalep.status === 'approved' ? 'bg-green-100 text-green-700' :
                    selectedTalep.status?.includes('rejected') ? 'bg-red-100 text-red-700' :
                    selectedTalep.status === 'completed' ? 'bg-blue-100 text-blue-700' :
                    'bg-yellow-100 text-yellow-700'
                  }>
                    {selectedTalep.status === 'approved' ? 'Onaylandı' :
                     selectedTalep.status?.includes('rejected') ? 'Reddedildi' :
                     selectedTalep.status === 'completed' ? 'Bitirildi' :
                     'Bekliyor'}
                  </Badge>
                </div>
              </div>
              
              {selectedTalep.description && (
                <div>
                  <Label className="text-gray-500 text-xs">Açıklama</Label>
                  <p className="text-sm mt-1 p-2 bg-gray-50 rounded">{selectedTalep.description}</p>
                </div>
              )}
              
              {selectedTalep.documents && selectedTalep.documents.length > 0 && (
                <div>
                  <Label className="text-gray-500 text-xs">Belgeler ({selectedTalep.documents.length})</Label>
                  <div className="space-y-2 mt-2">
                    {selectedTalep.documents.map((doc, idx) => (
                      <div key={idx} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                        <div className="flex items-center gap-2">
                          <File className="h-4 w-4 text-gray-500" />
                          <span className="text-sm">{doc.name}</span>
                        </div>
                        {(doc.url || doc.data) && (
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => {
                              const fileSrc = doc.url || doc.data;
                              if (fileSrc.startsWith('data:')) {
                                const link = document.createElement('a');
                                link.href = fileSrc;
                                link.download = doc.name;
                                link.click();
                              } else {
                                window.open(fileSrc, '_blank');
                              }
                            }}
                            className="text-blue-600"
                          >
                            <Download className="h-4 w-4" />
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* İşlem butonları (sadece gelen bekleyen talepler için) */}
              {(selectedTalep.status === 'forwarded_to_hr' || selectedTalep.status === 'pending_hr') && (
                <div className="border-t pt-4 mt-4 space-y-4">
                  <Label className="text-gray-700 font-medium">İşlem Yap</Label>
                  
                  <div>
                    <Label className="text-gray-500 text-xs">Açıklama / Not</Label>
                    <Textarea
                      value={talepActionNote}
                      onChange={(e) => setTalepActionNote(e.target.value)}
                      placeholder="İşlem ile ilgili notunuzu yazın..."
                      rows={2}
                      className="mt-1"
                    />
                  </div>
                  
                  <div className="flex flex-wrap gap-2">
                    <Button
                      onClick={() => handleTalepAction('approve')}
                      disabled={talepActionLoading}
                      className="bg-green-600 hover:bg-green-700 text-white"
                      data-testid="talep-approve-btn"
                    >
                      {talepActionLoading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <CheckCircle className="h-4 w-4 mr-2" />}
                      Onayla
                    </Button>
                    <Button
                      onClick={handleApproveAndConvertToJob}
                      disabled={talepActionLoading}
                      className="bg-indigo-600 hover:bg-indigo-700 text-white"
                      data-testid="talep-approve-convert-btn"
                    >
                      <Briefcase className="h-4 w-4 mr-2" />
                      Onayla ve İşe Çevir
                    </Button>
                    <Button
                      onClick={() => handleTalepAction('complete')}
                      disabled={talepActionLoading}
                      className="bg-blue-600 hover:bg-blue-700 text-white"
                      data-testid="talep-complete-btn"
                    >
                      {talepActionLoading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <CheckCircle className="h-4 w-4 mr-2" />}
                      Bitir
                    </Button>
                    <Button
                      onClick={() => handleTalepAction('reject')}
                      disabled={talepActionLoading}
                      variant="outline"
                      className="border-red-300 text-red-700 hover:bg-red-50"
                      data-testid="talep-reject-btn"
                    >
                      {talepActionLoading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <XCircle className="h-4 w-4 mr-2" />}
                      Reddet
                    </Button>
                  </div>
                </div>
              )}
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => { setSelectedTalep(null); setTalepActionNote(''); }}>Kapat</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Onayla ve İşe Çevir Modal */}
      <Dialog open={convertToJobModalOpen} onOpenChange={(open) => {
        setConvertToJobModalOpen(open);
        if (!open) {
          setConvertJobFormData({
            name: '',
            description: '',
            company: '',
            start_date: new Date().toISOString().split('T')[0],
            estimated_end_date: '',
            locations: [''],
            tracking_users: []
          });
        }
      }}>
        <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-indigo-600">
              <Briefcase className="h-5 w-5" />
              Talebi Onayla ve İşe Çevir
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            {/* Kaynak Talep Bilgisi */}
            {selectedTalep && (
              <div className="p-3 bg-indigo-50 rounded-lg border border-indigo-200">
                <div className="flex items-center gap-2 text-sm text-indigo-800">
                  <Inbox className="h-4 w-4" />
                  <span className="font-medium">Kaynak Talep:</span>
                  <span>{selectedTalep.request_number}</span>
                  <span className="text-indigo-600">- {selectedTalep.owner_name}</span>
                </div>
              </div>
            )}
            
            <div className="space-y-2">
              <Label htmlFor="convert-name">İşin Adı *</Label>
              <Input
                id="convert-name"
                value={convertJobFormData.name}
                onChange={(e) => setConvertJobFormData(prev => ({ ...prev, name: e.target.value }))}
                placeholder="İşin adı"
                data-testid="convert-job-name"
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="convert-company">İşi Yapan Şirket *</Label>
              <Input
                id="convert-company"
                value={convertJobFormData.company}
                onChange={(e) => setConvertJobFormData(prev => ({ ...prev, company: e.target.value }))}
                placeholder="Şirket adı"
                data-testid="convert-job-company"
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="convert-start-date">Başlangıç Tarihi</Label>
                <Input
                  id="convert-start-date"
                  type="date"
                  value={convertJobFormData.start_date}
                  onChange={(e) => setConvertJobFormData(prev => ({ ...prev, start_date: e.target.value }))}
                  data-testid="convert-job-start-date"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="convert-end-date">Tahmini Bitiş Tarihi</Label>
                <Input
                  id="convert-end-date"
                  type="date"
                  value={convertJobFormData.estimated_end_date}
                  onChange={(e) => setConvertJobFormData(prev => ({ ...prev, estimated_end_date: e.target.value }))}
                  data-testid="convert-job-end-date"
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="convert-description">Açıklama</Label>
              <Textarea
                id="convert-description"
                value={convertJobFormData.description}
                onChange={(e) => setConvertJobFormData(prev => ({ ...prev, description: e.target.value }))}
                placeholder="İşin açıklaması"
                rows={3}
                data-testid="convert-job-description"
              />
            </div>
            
            {/* İşi Takip Eden Kişiler */}
            <div className="space-y-2">
              <Label className="flex items-center gap-2">
                <Users className="h-4 w-4" />
                İşi Takip Eden Kişiler
              </Label>
              <div className="border rounded-md p-3 max-h-40 overflow-y-auto space-y-2">
                {hrUsers.length === 0 ? (
                  <p className="text-sm text-gray-500">Kullanıcı bulunamadı</p>
                ) : (
                  hrUsers.map(user => (
                    <div key={user.id} className="flex items-center space-x-2">
                      <Checkbox
                        id={`convert-user-${user.id}`}
                        checked={convertJobFormData.tracking_users.includes(user.id)}
                        onCheckedChange={(checked) => {
                          setConvertJobFormData(prev => ({
                            ...prev,
                            tracking_users: checked 
                              ? [...prev.tracking_users, user.id]
                              : prev.tracking_users.filter(id => id !== user.id)
                          }));
                        }}
                      />
                      <label htmlFor={`convert-user-${user.id}`} className="text-sm cursor-pointer">
                        {user.name}
                      </label>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button 
              variant="outline" 
              onClick={() => {
                setConvertToJobModalOpen(false);
                setConvertJobFormData({
                  name: '',
                  description: '',
                  company: '',
                  start_date: new Date().toISOString().split('T')[0],
                  estimated_end_date: '',
                  locations: [''],
                  tracking_users: []
                });
              }}
              data-testid="convert-job-cancel"
            >
              İptal
            </Button>
            <Button 
              onClick={handleSubmitConvertToJob}
              disabled={convertJobSubmitting}
              className="bg-indigo-600 hover:bg-indigo-700"
              data-testid="convert-job-submit"
            >
              {convertJobSubmitting ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin mr-2" />
                  Kaydediliyor...
                </>
              ) : (
                <>
                  <Briefcase className="h-4 w-4 mr-2" />
                  Onayla ve İşe Çevir
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Create Modal */}
      <Dialog open={createModalOpen} onOpenChange={setCreateModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Briefcase className="h-5 w-5 text-violet-600" />
              Yeni İş Ekle
            </DialogTitle>
          </DialogHeader>
          {renderFormContent(false)}
          <DialogFooter>
            <Button variant="outline" onClick={() => setCreateModalOpen(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleCreateJob} 
              className="bg-violet-600 hover:bg-violet-700"
              data-testid="create-job-btn"
            >
              Oluştur
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Modal */}
      <Dialog open={editModalOpen} onOpenChange={setEditModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Briefcase className="h-5 w-5 text-violet-600" />
              İş Düzenle
            </DialogTitle>
          </DialogHeader>
          {renderFormContent(true)}
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditModalOpen(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleEditJob} 
              className="bg-violet-600 hover:bg-violet-700"
              data-testid="save-job-btn"
            >
              Kaydet
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Detail Modal */}
      <Dialog open={detailModalOpen} onOpenChange={setDetailModalOpen}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Briefcase className="h-5 w-5 text-violet-600" />
              İş Detayı
            </DialogTitle>
          </DialogHeader>
          {selectedJob && (
            <div className="space-y-4 py-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500">İş Adı</Label>
                  <p className="font-medium text-lg">{selectedJob.name}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Durum</Label>
                  <div className="mt-1">{getStatusBadge(selectedJob.status)}</div>
                </div>
              </div>
              
              {/* İlerleme */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <Label className="text-gray-500 flex items-center gap-2">
                    <Percent className="h-4 w-4" />
                    İş İlerleme
                  </Label>
                  <span className="text-lg font-bold text-violet-600">{selectedJob.progress || 0}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3 mb-3">
                  <div 
                    className={`h-3 rounded-full ${getProgressColor(selectedJob.progress || 0)}`}
                    style={{ width: `${selectedJob.progress || 0}%` }}
                  />
                </div>
                <Button 
                  onClick={() => openProgressModal(selectedJob)}
                  className="w-full bg-violet-600 hover:bg-violet-700"
                  data-testid="update-progress-btn"
                >
                  <Percent className="h-4 w-4 mr-2" />
                  İlerleme Seviyesi Gir
                </Button>
              </div>
              
              <div>
                <Label className="text-gray-500">İşi Yapan Şirket</Label>
                <div className="flex items-center gap-2 mt-1">
                  <Building2 className="h-4 w-4 text-violet-600" />
                  <p className="font-medium">{selectedJob.company}</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500">Başlangıç Tarihi</Label>
                  <div className="flex items-center gap-2 mt-1">
                    <Calendar className="h-4 w-4 text-violet-600" />
                    <p>{selectedJob.start_date}</p>
                  </div>
                </div>
                <div>
                  <Label className="text-gray-500">Tahmini Bitiş Tarihi</Label>
                  <div className="flex items-center gap-2 mt-1">
                    <Calendar className="h-4 w-4 text-violet-600" />
                    <p>{selectedJob.estimated_end_date}</p>
                  </div>
                </div>
              </div>
              
              <div>
                <Label className="text-gray-500">İşi Takip Edenler</Label>
                <div className="flex flex-wrap gap-2 mt-2">
                  {selectedJob.tracking_user_details?.length > 0 ? (
                    selectedJob.tracking_user_details.map((user, idx) => (
                      <Badge key={idx} className="bg-amber-100 text-violet-700">
                        <Users className="h-3 w-3 mr-1" />
                        {user.name}
                      </Badge>
                    ))
                  ) : (
                    <p className="text-gray-400">Takip eden yok</p>
                  )}
                </div>
              </div>
              
              <div>
                <Label className="text-gray-500">Konum(lar)</Label>
                <div className="flex flex-wrap gap-2 mt-2">
                  {selectedJob.locations?.length > 0 ? (
                    selectedJob.locations.map((loc, idx) => (
                      <Badge key={idx} variant="secondary">
                        <MapPin className="h-3 w-3 mr-1" />
                        {loc}
                      </Badge>
                    ))
                  ) : (
                    <p className="text-gray-400">Konum belirtilmemiş</p>
                  )}
                </div>
              </div>
              
              {selectedJob.description && (
                <div>
                  <Label className="text-gray-500">Açıklama</Label>
                  <p className="mt-1 whitespace-pre-wrap">{selectedJob.description}</p>
                </div>
              )}
              
              {/* İş ile Alakalı Belgeler */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <Label className="text-gray-700 flex items-center gap-2 mb-3">
                  <File className="h-4 w-4 text-violet-600" />
                  İş ile Alakalı Belgeler
                </Label>
                {jobDocumentsLoading ? (
                  <div className="flex items-center justify-center py-4">
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-violet-600"></div>
                    <span className="ml-2 text-sm text-gray-500">Belgeler yükleniyor...</span>
                  </div>
                ) : jobDocuments.length > 0 ? (
                  <div className="space-y-2">
                    {jobDocuments.map((doc, index) => (
                      <div 
                        key={doc.id || index} 
                        className="flex items-center justify-between bg-white p-3 rounded-md border border-gray-200 hover:border-amber-300 transition-colors"
                      >
                        <div className="flex items-center gap-3">
                          <div className="p-2 bg-amber-100 rounded">
                            <FileIcon className="h-5 w-5 text-violet-600" />
                          </div>
                          <div>
                            <p className="font-medium text-sm">{doc.original_filename || doc.filename}</p>
                            <p className="text-xs text-gray-400">
                              {doc.created_at ? new Date(doc.created_at).toLocaleDateString('tr-TR') : ''}
                              {doc.file_size && ` • ${(doc.file_size / 1024).toFixed(1)} KB`}
                            </p>
                          </div>
                        </div>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => downloadJobDocument(doc)}
                          className="text-violet-600 hover:text-violet-700 hover:bg-violet-50"
                          data-testid={`download-doc-${doc.id}`}
                        >
                          <Download className="h-4 w-4 mr-1" />
                          İndir
                        </Button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-center text-gray-400 py-4">Bu işe ait belge bulunmuyor</p>
                )}
              </div>
              
              {/* İptal Bilgileri */}
              {selectedJob.status === 'cancelled' && selectedJob.cancellation_reason && (
                <div className="bg-red-50 border border-red-200 p-4 rounded-lg">
                  <Label className="text-red-700 flex items-center gap-2 mb-2">
                    <XCircle className="h-4 w-4" />
                    İptal Bilgileri
                  </Label>
                  <p className="text-sm text-red-800 whitespace-pre-wrap">{selectedJob.cancellation_reason}</p>
                  <p className="text-xs text-red-500 mt-2">
                    İptal Eden: {selectedJob.cancelled_by_name || '-'} | 
                    Tarih: {selectedJob.cancelled_at ? new Date(selectedJob.cancelled_at).toLocaleString('tr-TR') : '-'}
                  </p>
                </div>
              )}
              
              <div className="pt-2 border-t">
                <p className="text-xs text-gray-400">
                  Oluşturan: {selectedJob.created_by_name} | 
                  Oluşturma: {selectedJob.created_at ? new Date(selectedJob.created_at).toLocaleString('tr-TR') : '-'}
                </p>
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setDetailModalOpen(false)}>Kapat</Button>
            {selectedJob?.status !== 'cancelled' && selectedJob?.status !== 'completed' && (
              <Button 
                className="bg-red-600 hover:bg-red-700"
                onClick={() => { setCancellationReason(''); setCancelModalOpen(true); }}
                data-testid="cancel-job-btn"
              >
                <XCircle className="h-4 w-4 mr-2" />
                İptal Et
              </Button>
            )}
            {selectedJob?.status !== 'cancelled' && selectedJob?.status !== 'completed' && (
              <Button 
                className="bg-violet-600 hover:bg-violet-700"
                onClick={() => {
                  setDetailModalOpen(false);
                  openEditModal(selectedJob);
                }}
              >
                <Edit className="h-4 w-4 mr-2" />
                Düzenle
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* İptal Modal */}
      <Dialog open={cancelModalOpen} onOpenChange={setCancelModalOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <XCircle className="h-5 w-5" />
              İşi İptal Et
            </DialogTitle>
            <DialogDescription>
              {selectedJob?.name} işini iptal etmek üzeresiniz. İptal açıklaması giriniz.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>İptal Açıklaması *</Label>
              <Textarea
                placeholder="İptal sebebini yazınız..."
                value={cancellationReason}
                onChange={(e) => setCancellationReason(e.target.value)}
                rows={4}
                data-testid="cancellation-reason-input"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setCancelModalOpen(false)}>Vazgeç</Button>
            <Button 
              className="bg-red-600 hover:bg-red-700"
              onClick={handleCancelJob}
              disabled={!cancellationReason.trim()}
              data-testid="confirm-cancel-job-btn"
            >
              <XCircle className="h-4 w-4 mr-2" />
              İptal Et
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Progress Modal */}
      <Dialog open={progressModalOpen} onOpenChange={setProgressModalOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Percent className="h-5 w-5 text-violet-600" />
              İş İlerleme Seviyesi
            </DialogTitle>
            <DialogDescription>
              {selectedJob?.name} işi için ilerleme seviyesini girin
            </DialogDescription>
          </DialogHeader>
          <div className="py-6">
            <div className="text-center mb-6">
              <span className="text-5xl font-bold text-violet-600">{progressValue}%</span>
            </div>
            <Slider
              value={[progressValue]}
              onValueChange={(vals) => setProgressValue(vals[0])}
              max={100}
              step={5}
              className="mb-4"
            />
            <div className="flex justify-between text-sm text-gray-500">
              <span>0%</span>
              <span>25%</span>
              <span>50%</span>
              <span>75%</span>
              <span>100%</span>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setProgressModalOpen(false)}>İptal</Button>
            <Button 
              className="bg-violet-600 hover:bg-violet-700"
              onClick={handleUpdateProgress}
              data-testid="save-progress-btn"
            >
              <CheckCircle className="h-4 w-4 mr-2" />
              Kaydet
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Archive Confirmation Modal */}
      <Dialog open={archiveModalOpen} onOpenChange={setArchiveModalOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="text-orange-600 flex items-center gap-2">
              <Archive className="h-5 w-5" />
              İşi Arşive Gönder
            </DialogTitle>
            <DialogDescription>
              "{selectedJob?.name}" işini arşive göndermek istediğinize emin misiniz? 
              İş tüm raporlar, iş programı ve görevleriyle birlikte arşive taşınacak.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setArchiveModalOpen(false)}>İptal</Button>
            <Button 
              className="bg-orange-600 hover:bg-orange-700"
              onClick={handleArchiveJob}
              data-testid="confirm-archive-job-btn"
            >
              <Archive className="h-4 w-4 mr-2" />
              Arşive Gönder
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Raporlar Modal */}
      <Dialog open={reportsModalOpen} onOpenChange={setReportsModalOpen}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-purple-600" />
              {selectedJob?.name} - Raporlar
            </DialogTitle>
          </DialogHeader>
          <div className="py-4">
            {itemLoading ? (
              <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-purple-600" /></div>
            ) : jobReports.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                <FileText className="h-12 w-12 mx-auto mb-2 opacity-50" />
                <p>Bu işe ait rapor yok</p>
              </div>
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Başlık</TableHead>
                    <TableHead>Tür</TableHead>
                    <TableHead>Oluşturan</TableHead>
                    <TableHead>Tarih</TableHead>
                    <TableHead>İşlem</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {jobReports.map(report => (
                    <TableRow key={report.id} className="cursor-pointer hover:bg-gray-50" onClick={() => viewReportDetail(report)}>
                      <TableCell className="font-medium">{report.title}</TableCell>
                      <TableCell>
                        <Badge variant="outline">{report.report_type === 'general' ? 'Genel' : report.report_type}</Badge>
                      </TableCell>
                      <TableCell>{report.created_by_name}</TableCell>
                      <TableCell>{report.created_at ? new Date(report.created_at).toLocaleDateString('tr-TR') : '-'}</TableCell>
                      <TableCell>
                        <div className="flex gap-1">
                          <Button size="sm" variant="outline" onClick={(e) => { e.stopPropagation(); viewReportDetail(report); }} title="Detay">
                            <Eye className="h-4 w-4 text-blue-600" />
                          </Button>
                          <Button size="sm" variant="outline" className="text-red-600" onClick={(e) => { e.stopPropagation(); handleDeleteReport(report.id); }} title="Sil">
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
            
            {/* Rapor Ekleme Formu */}
            {addReportOpen ? (
              <div className="mt-4 p-4 border rounded-lg bg-gray-50 space-y-3">
                <h4 className="font-medium flex items-center gap-2"><Plus className="h-4 w-4" />Yeni Rapor Ekle</h4>
                <div className="space-y-2">
                  <Label>Başlık *</Label>
                  <Input 
                    value={newReport.title} 
                    onChange={(e) => setNewReport(prev => ({...prev, title: e.target.value}))}
                    placeholder="Rapor başlığı"
                    data-testid="new-report-title"
                  />
                </div>
                <div className="space-y-2">
                  <Label>İçerik</Label>
                  <Textarea 
                    value={newReport.content} 
                    onChange={(e) => setNewReport(prev => ({...prev, content: e.target.value}))}
                    placeholder="Rapor içeriği"
                    rows={3}
                  />
                </div>
                {/* Belge Yükleme */}
                <div className="space-y-2">
                  <Label className="flex items-center gap-2"><Upload className="h-4 w-4" />Belgeler</Label>
                  <DocumentUploader inputId="report-file-upload" />
                  <SelectedFilesList />
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" onClick={() => { setAddReportOpen(false); setSelectedFiles([]); }}>İptal</Button>
                  <Button onClick={handleAddReport} className="bg-purple-600 hover:bg-purple-700" data-testid="submit-new-report" disabled={uploadingFiles}>
                    {uploadingFiles ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Plus className="h-4 w-4 mr-1" />}
                    {uploadingFiles ? 'Yükleniyor...' : 'Ekle'}
                  </Button>
                </div>
              </div>
            ) : (
              <Button 
                className="mt-4 w-full bg-purple-600 hover:bg-purple-700" 
                onClick={() => setAddReportOpen(true)}
                data-testid="add-report-btn"
              >
                <Plus className="h-4 w-4 mr-2" />
                Yeni Rapor Ekle
              </Button>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* İş Programı Modal */}
      <Dialog open={schedulesModalOpen} onOpenChange={setSchedulesModalOpen}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CalendarDays className="h-5 w-5 text-blue-600" />
              {selectedJob?.name} - İş Programı
            </DialogTitle>
          </DialogHeader>
          <div className="py-4">
            {itemLoading ? (
              <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-blue-600" /></div>
            ) : jobSchedules.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                <CalendarDays className="h-12 w-12 mx-auto mb-2 opacity-50" />
                <p>Bu işe ait iş programı yok</p>
              </div>
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Başlık</TableHead>
                    <TableHead>Tarih</TableHead>
                    <TableHead>Saat</TableHead>
                    <TableHead>Durum</TableHead>
                    <TableHead>Oluşturan</TableHead>
                    <TableHead>İşlem</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {jobSchedules.map(schedule => (
                    <TableRow key={schedule.id} className="cursor-pointer hover:bg-gray-50" onClick={() => viewScheduleDetail(schedule)}>
                      <TableCell className="font-medium">{schedule.title}</TableCell>
                      <TableCell>{schedule.scheduled_date}</TableCell>
                      <TableCell>{schedule.scheduled_time || '-'}</TableCell>
                      <TableCell>
                        <Badge className={schedule.status === 'completed' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}>
                          {schedule.status === 'completed' ? 'Tamamlandı' : 'Bekliyor'}
                        </Badge>
                      </TableCell>
                      <TableCell>{schedule.created_by_name}</TableCell>
                      <TableCell>
                        <div className="flex gap-1">
                          <Button size="sm" variant="outline" onClick={(e) => { e.stopPropagation(); viewScheduleDetail(schedule); }} title="Detay">
                            <Eye className="h-4 w-4 text-blue-600" />
                          </Button>
                          <Button size="sm" variant="outline" className="text-red-600" onClick={(e) => { e.stopPropagation(); handleDeleteSchedule(schedule.id); }} title="Sil">
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
            
            {/* İş Programı Ekleme Formu */}
            {addScheduleOpen ? (
              <div className="mt-4 p-4 border rounded-lg bg-gray-50 space-y-3">
                <h4 className="font-medium flex items-center gap-2"><Plus className="h-4 w-4" />Yeni İş Programı Ekle</h4>
                <div className="space-y-2">
                  <Label>Başlık *</Label>
                  <Input 
                    value={newSchedule.title} 
                    onChange={(e) => setNewSchedule(prev => ({...prev, title: e.target.value}))}
                    placeholder="İş programı başlığı"
                    data-testid="new-schedule-title"
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-2">
                    <Label>Tarih *</Label>
                    <Input 
                      type="date"
                      value={newSchedule.scheduled_date} 
                      onChange={(e) => setNewSchedule(prev => ({...prev, scheduled_date: e.target.value}))}
                      data-testid="new-schedule-date"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label>Saat</Label>
                    <Input 
                      type="time"
                      value={newSchedule.scheduled_time} 
                      onChange={(e) => setNewSchedule(prev => ({...prev, scheduled_time: e.target.value}))}
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  <Label>Açıklama</Label>
                  <Textarea 
                    value={newSchedule.description} 
                    onChange={(e) => setNewSchedule(prev => ({...prev, description: e.target.value}))}
                    placeholder="Açıklama"
                    rows={2}
                  />
                </div>
                {/* Belge Yükleme */}
                <div className="space-y-2">
                  <Label className="flex items-center gap-2"><Upload className="h-4 w-4" />Belgeler</Label>
                  <DocumentUploader inputId="schedule-file-upload" />
                  <SelectedFilesList />
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" onClick={() => { setAddScheduleOpen(false); setSelectedFiles([]); }}>İptal</Button>
                  <Button onClick={handleAddSchedule} className="bg-blue-600 hover:bg-blue-700" data-testid="submit-new-schedule" disabled={uploadingFiles}>
                    {uploadingFiles ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Plus className="h-4 w-4 mr-1" />}
                    {uploadingFiles ? 'Yükleniyor...' : 'Ekle'}
                  </Button>
                </div>
              </div>
            ) : (
              <Button 
                className="mt-4 w-full bg-blue-600 hover:bg-blue-700" 
                onClick={() => setAddScheduleOpen(true)}
                data-testid="add-schedule-btn"
              >
                <Plus className="h-4 w-4 mr-2" />
                Yeni İş Programı Ekle
              </Button>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Görevler Modal */}
      <Dialog open={tasksModalOpen} onOpenChange={setTasksModalOpen}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ClipboardList className="h-5 w-5 text-green-600" />
              {selectedJob?.name} - Görevler
            </DialogTitle>
          </DialogHeader>
          <div className="py-4">
            {itemLoading ? (
              <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-green-600" /></div>
            ) : jobTasks.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                <ClipboardList className="h-12 w-12 mx-auto mb-2 opacity-50" />
                <p>Bu işe ait görev yok</p>
              </div>
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Başlık</TableHead>
                    <TableHead>Atanan</TableHead>
                    <TableHead>Bitiş Tarihi</TableHead>
                    <TableHead>Öncelik</TableHead>
                    <TableHead>Durum</TableHead>
                    <TableHead>İşlem</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {jobTasks.map(task => (
                    <TableRow key={task.id} className="cursor-pointer hover:bg-gray-50" onClick={() => viewTaskDetail(task)}>
                      <TableCell className="font-medium">{task.title}</TableCell>
                      <TableCell>{task.assigned_to_name || '-'}</TableCell>
                      <TableCell>{task.due_date || '-'}</TableCell>
                      <TableCell>{getPriorityBadge(task.priority)}</TableCell>
                      <TableCell>{getTaskStatusBadge(task.status)}</TableCell>
                      <TableCell>
                        <div className="flex gap-1">
                          <Button size="sm" variant="outline" onClick={(e) => { e.stopPropagation(); viewTaskDetail(task); }} title="Detay">
                            <Eye className="h-4 w-4 text-blue-600" />
                          </Button>
                          <Button size="sm" variant="outline" className="text-red-600" onClick={(e) => { e.stopPropagation(); handleDeleteTask(task.id); }} title="Sil">
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
            
            {/* Görev Ekleme Formu */}
            {addTaskOpen ? (
              <div className="mt-4 p-4 border rounded-lg bg-gray-50 space-y-3">
                <h4 className="font-medium flex items-center gap-2"><Plus className="h-4 w-4" />Yeni Görev Ekle</h4>
                <div className="space-y-2">
                  <Label>Başlık *</Label>
                  <Input 
                    value={newTask.title} 
                    onChange={(e) => setNewTask(prev => ({...prev, title: e.target.value}))}
                    placeholder="Görev başlığı"
                    data-testid="new-task-title"
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-2">
                    <Label>Atanan Kişi</Label>
                    <Select value={newTask.assigned_to} onValueChange={(value) => setNewTask(prev => ({...prev, assigned_to: value}))}>
                      <SelectTrigger>
                        <SelectValue placeholder="Kişi seçin" />
                      </SelectTrigger>
                      <SelectContent>
                        {hrUsers.map(user => (
                          <SelectItem key={user.id} value={user.id}>{user.name}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <div className="space-y-2">
                    <Label>Bitiş Tarihi</Label>
                    <Input 
                      type="date"
                      value={newTask.due_date} 
                      onChange={(e) => setNewTask(prev => ({...prev, due_date: e.target.value}))}
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  <Label>Öncelik</Label>
                  <Select value={newTask.priority} onValueChange={(value) => setNewTask(prev => ({...prev, priority: value}))}>
                    <SelectTrigger>
                      <SelectValue placeholder="Öncelik seçin" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="low">Düşük</SelectItem>
                      <SelectItem value="normal">Normal</SelectItem>
                      <SelectItem value="high">Yüksek</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2">
                  <Label>Açıklama</Label>
                  <Textarea 
                    value={newTask.description} 
                    onChange={(e) => setNewTask(prev => ({...prev, description: e.target.value}))}
                    placeholder="Görev açıklaması"
                    rows={2}
                  />
                </div>
                {/* Belge Yükleme */}
                <div className="space-y-2">
                  <Label className="flex items-center gap-2"><Upload className="h-4 w-4" />Belgeler</Label>
                  <DocumentUploader inputId="task-file-upload" />
                  <SelectedFilesList />
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" onClick={() => { setAddTaskOpen(false); setSelectedFiles([]); }}>İptal</Button>
                  <Button onClick={handleAddTask} className="bg-green-600 hover:bg-green-700" data-testid="submit-new-task" disabled={uploadingFiles}>
                    {uploadingFiles ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Plus className="h-4 w-4 mr-1" />}
                    {uploadingFiles ? 'Yükleniyor...' : 'Ekle'}
                  </Button>
                </div>
              </div>
            ) : (
              <Button 
                className="mt-4 w-full bg-green-600 hover:bg-green-700" 
                onClick={() => setAddTaskOpen(true)}
                data-testid="add-task-btn"
              >
                <Plus className="h-4 w-4 mr-2" />
                Yeni Görev Ekle
              </Button>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Belge Önizleme Modal */}
      <Dialog open={previewModalOpen} onOpenChange={setPreviewModalOpen}>
        <DialogContent className="max-w-4xl max-h-[90vh]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Eye className="h-5 w-5" />
              Belge Önizleme: {previewDoc?.original_filename}
            </DialogTitle>
          </DialogHeader>
          <div className="flex-1 overflow-auto">
            {previewDoc && (
              previewDoc.file_extension === '.pdf' ? (
                <iframe 
                  src={`${API}/documents/${previewDoc.id}/preview`}
                  className="w-full h-[70vh] border rounded"
                  title="PDF Preview"
                />
              ) : (
                <img 
                  src={`${API}/documents/${previewDoc.id}/preview`}
                  alt={previewDoc.original_filename}
                  className="max-w-full max-h-[70vh] mx-auto"
                />
              )
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => handleDownloadDocument(previewDoc)}>
              <Download className="h-4 w-4 mr-2" />
              İndir
            </Button>
            <Button onClick={() => setPreviewModalOpen(false)}>Kapat</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Rapor Detay Modal */}
      <Dialog open={reportDetailModal} onOpenChange={setReportDetailModal}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-purple-600" />
              Rapor Detayı
            </DialogTitle>
          </DialogHeader>
          {selectedReport && (
            <div className="space-y-4 py-4">
              <div>
                <Label className="text-gray-500">Başlık</Label>
                <p className="font-medium text-lg">{selectedReport.title}</p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500">Rapor Türü</Label>
                  <p className="font-medium">{selectedReport.report_type === 'general' ? 'Genel' : selectedReport.report_type}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Oluşturma Tarihi</Label>
                  <p className="font-medium">{selectedReport.created_at ? new Date(selectedReport.created_at).toLocaleString('tr-TR') : '-'}</p>
                </div>
              </div>
              <div>
                <Label className="text-gray-500">Oluşturan</Label>
                <p className="font-medium">{selectedReport.created_by_name}</p>
              </div>
              {selectedReport.content && (
                <div>
                  <Label className="text-gray-500">İçerik</Label>
                  <p className="mt-1 whitespace-pre-wrap bg-gray-50 p-3 rounded">{selectedReport.content}</p>
                </div>
              )}
              <DocumentsList documents={itemDocuments} onRefresh={() => viewReportDetail(selectedReport)} />
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setReportDetailModal(false)}>Kapat</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* İş Programı Detay Modal */}
      <Dialog open={scheduleDetailModal} onOpenChange={setScheduleDetailModal}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CalendarDays className="h-5 w-5 text-blue-600" />
              İş Programı Detayı
            </DialogTitle>
          </DialogHeader>
          {selectedSchedule && (
            <div className="space-y-4 py-4">
              <div>
                <Label className="text-gray-500">Başlık</Label>
                <p className="font-medium text-lg">{selectedSchedule.title}</p>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <Label className="text-gray-500">Tarih</Label>
                  <p className="font-medium">{selectedSchedule.scheduled_date}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Saat</Label>
                  <p className="font-medium">{selectedSchedule.scheduled_time || '-'}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Durum</Label>
                  <Badge className={selectedSchedule.status === 'completed' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}>
                    {selectedSchedule.status === 'completed' ? 'Tamamlandı' : 'Bekliyor'}
                  </Badge>
                </div>
              </div>
              <div>
                <Label className="text-gray-500">Oluşturan</Label>
                <p className="font-medium">{selectedSchedule.created_by_name}</p>
              </div>
              {selectedSchedule.completed_at && (
                <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                  <Label className="text-green-700">Tamamlanma Bilgisi</Label>
                  <p className="text-sm text-green-600 mt-1">
                    {selectedSchedule.completed_by_name} tarafından {new Date(selectedSchedule.completed_at).toLocaleString('tr-TR')} tarihinde tamamlandı
                  </p>
                </div>
              )}
              {selectedSchedule.description && (
                <div>
                  <Label className="text-gray-500">Açıklama</Label>
                  <p className="mt-1 whitespace-pre-wrap bg-gray-50 p-3 rounded">{selectedSchedule.description}</p>
                </div>
              )}
              
              {/* Güncellemeler Geçmişi */}
              {selectedSchedule.updates && selectedSchedule.updates.length > 0 && (
                <div>
                  <Label className="text-gray-500 flex items-center gap-2">
                    <History className="h-4 w-4" />
                    Güncellemeler ({selectedSchedule.updates.length})
                  </Label>
                  <div className="mt-2 space-y-3 max-h-60 overflow-y-auto">
                    {selectedSchedule.updates.map((update, idx) => (
                      <div key={update.id || idx} className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                        <div className="flex justify-between items-start mb-2">
                          <span className="font-medium text-blue-800 text-sm">{update.created_by_name}</span>
                          <span className="text-xs text-blue-600">
                            {new Date(update.created_at).toLocaleString('tr-TR')}
                          </span>
                        </div>
                        <p className="text-sm text-gray-700 whitespace-pre-wrap">{update.description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              <DocumentsList documents={itemDocuments} onRefresh={() => viewScheduleDetail(selectedSchedule)} />
              
              {/* İşlem Butonları */}
              {selectedSchedule.status !== 'completed' && (
                <div className="flex gap-2 pt-4 border-t">
                  <Button 
                    onClick={openScheduleUpdateModal}
                    variant="outline"
                    className="flex-1"
                    data-testid="schedule-update-btn"
                  >
                    <FileText className="h-4 w-4 mr-2" />
                    Güncelle
                  </Button>
                  <Button 
                    onClick={handleCompleteSchedule}
                    className="flex-1 bg-green-600 hover:bg-green-700"
                    disabled={completingSchedule}
                    data-testid="schedule-complete-btn"
                  >
                    {completingSchedule ? (
                      <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    ) : (
                      <CheckCircle className="h-4 w-4 mr-2" />
                    )}
                    Tamamla
                  </Button>
                </div>
              )}
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setScheduleDetailModal(false)}>Kapat</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* İş Programı Güncelleme Modal */}
      <Dialog open={scheduleUpdateModal} onOpenChange={setScheduleUpdateModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-blue-600" />
              İş Programı Güncellemesi
            </DialogTitle>
            <DialogDescription>
              Yaptığınız işleri yazın ve gerekirse belge ekleyin.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Yapılan İşler *</Label>
              <Textarea
                value={scheduleUpdateText}
                onChange={(e) => setScheduleUpdateText(e.target.value)}
                placeholder="İş programı ile ilgili yaptığınız işleri detaylı açıklayın..."
                rows={4}
                data-testid="schedule-update-description"
              />
            </div>
            
            <div className="space-y-2">
              <Label className="flex items-center gap-2">
                <Upload className="h-4 w-4" />
                Belgeler (Opsiyonel)
              </Label>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-500 transition-colors">
                <input
                  type="file"
                  multiple
                  onChange={handleScheduleUpdateFileSelect}
                  className="hidden"
                  id="schedule-update-file-upload"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.png,.jpg,.jpeg,.gif,.zip,.rar"
                />
                <label htmlFor="schedule-update-file-upload" className="cursor-pointer">
                  <Upload className="h-8 w-8 mx-auto text-gray-400 mb-2" />
                  <p className="text-sm text-gray-600">Belge eklemek için tıklayın</p>
                  <p className="text-xs text-gray-400 mt-1">PDF, Word, Excel, Resim (max 10MB)</p>
                </label>
              </div>
              
              {scheduleUpdateFiles.length > 0 && (
                <div className="space-y-2 mt-2">
                  {scheduleUpdateFiles.map((file, index) => (
                    <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                      <div className="flex items-center gap-2">
                        <FileText className="h-4 w-4 text-blue-600" />
                        <span className="text-sm truncate max-w-[200px]">{file.name}</span>
                        <span className="text-xs text-gray-400">({(file.size / 1024).toFixed(1)} KB)</span>
                      </div>
                      <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        onClick={() => removeScheduleUpdateFile(index)}
                      >
                        <X className="h-4 w-4 text-red-500" />
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setScheduleUpdateModal(false)}>İptal</Button>
            <Button 
              onClick={handleSubmitScheduleUpdate}
              className="bg-blue-600 hover:bg-blue-700"
              disabled={submittingScheduleUpdate || !scheduleUpdateText.trim()}
              data-testid="submit-schedule-update"
            >
              {submittingScheduleUpdate ? (
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              ) : (
                <CheckCircle className="h-4 w-4 mr-2" />
              )}
              Güncellemeyi Kaydet
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Görev Detay Modal */}
      <Dialog open={taskDetailModal} onOpenChange={setTaskDetailModal}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ClipboardList className="h-5 w-5 text-green-600" />
              Görev Detayı
            </DialogTitle>
          </DialogHeader>
          {selectedTask && (
            <div className="space-y-4 py-4">
              <div>
                <Label className="text-gray-500">Başlık</Label>
                <p className="font-medium text-lg">{selectedTask.title}</p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500">Atanan Kişi</Label>
                  <p className="font-medium">{selectedTask.assigned_to_name || '-'}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Bitiş Tarihi</Label>
                  <p className="font-medium">{selectedTask.due_date || '-'}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Öncelik</Label>
                  <div className="mt-1">{getPriorityBadge(selectedTask.priority)}</div>
                </div>
                <div>
                  <Label className="text-gray-500">Durum</Label>
                  <div className="mt-1">{getTaskStatusBadge(selectedTask.status)}</div>
                </div>
              </div>
              <div>
                <Label className="text-gray-500">Oluşturan</Label>
                <p className="font-medium">{selectedTask.created_by_name}</p>
              </div>
              {selectedTask.completed_at && (
                <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                  <Label className="text-green-700">Tamamlanma Bilgisi</Label>
                  <p className="text-sm text-green-600 mt-1">
                    {selectedTask.completed_by_name} tarafından {new Date(selectedTask.completed_at).toLocaleString('tr-TR')} tarihinde tamamlandı
                  </p>
                </div>
              )}
              {selectedTask.description && (
                <div>
                  <Label className="text-gray-500">Açıklama</Label>
                  <p className="mt-1 whitespace-pre-wrap bg-gray-50 p-3 rounded">{selectedTask.description}</p>
                </div>
              )}
              
              {/* Güncellemeler Geçmişi */}
              {selectedTask.updates && selectedTask.updates.length > 0 && (
                <div>
                  <Label className="text-gray-500 flex items-center gap-2">
                    <History className="h-4 w-4" />
                    Güncellemeler ({selectedTask.updates.length})
                  </Label>
                  <div className="mt-2 space-y-3 max-h-60 overflow-y-auto">
                    {selectedTask.updates.map((update, idx) => (
                      <div key={update.id || idx} className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                        <div className="flex justify-between items-start mb-2">
                          <span className="font-medium text-blue-800 text-sm">{update.created_by_name}</span>
                          <span className="text-xs text-blue-600">
                            {new Date(update.created_at).toLocaleString('tr-TR')}
                          </span>
                        </div>
                        <p className="text-sm text-gray-700 whitespace-pre-wrap">{update.description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              <DocumentsList documents={itemDocuments} onRefresh={() => viewTaskDetail(selectedTask)} />
              
              {/* İşlem Butonları */}
              {selectedTask.status !== 'completed' && (
                <div className="flex gap-2 pt-4 border-t">
                  <Button 
                    onClick={openTaskUpdateModal}
                    variant="outline"
                    className="flex-1"
                    data-testid="task-update-btn"
                  >
                    <FileText className="h-4 w-4 mr-2" />
                    Güncelle
                  </Button>
                  <Button 
                    onClick={handleCompleteTask}
                    className="flex-1 bg-green-600 hover:bg-green-700"
                    disabled={completingTask}
                    data-testid="task-complete-btn"
                  >
                    {completingTask ? (
                      <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    ) : (
                      <CheckCircle className="h-4 w-4 mr-2" />
                    )}
                    Görevi Bitir
                  </Button>
                </div>
              )}
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setTaskDetailModal(false)}>Kapat</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Görev Güncelleme Modal */}
      <Dialog open={taskUpdateModal} onOpenChange={setTaskUpdateModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-blue-600" />
              Görev Güncellemesi
            </DialogTitle>
            <DialogDescription>
              Yaptığınız işleri yazın ve gerekirse belge ekleyin.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Yapılan İşler *</Label>
              <Textarea
                value={taskUpdateText}
                onChange={(e) => setTaskUpdateText(e.target.value)}
                placeholder="Görevle ilgili yaptığınız işleri detaylı açıklayın..."
                rows={4}
                data-testid="task-update-description"
              />
            </div>
            
            <div className="space-y-2">
              <Label className="flex items-center gap-2">
                <Upload className="h-4 w-4" />
                Belgeler (Opsiyonel)
              </Label>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-500 transition-colors">
                <input
                  type="file"
                  multiple
                  onChange={handleTaskUpdateFileSelect}
                  className="hidden"
                  id="task-update-file-upload"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.png,.jpg,.jpeg,.gif,.zip,.rar"
                />
                <label htmlFor="task-update-file-upload" className="cursor-pointer">
                  <Upload className="h-8 w-8 mx-auto text-gray-400 mb-2" />
                  <p className="text-sm text-gray-600">Belge eklemek için tıklayın</p>
                  <p className="text-xs text-gray-400 mt-1">PDF, Word, Excel, Resim (max 10MB)</p>
                </label>
              </div>
              
              {taskUpdateFiles.length > 0 && (
                <div className="space-y-2 mt-2">
                  {taskUpdateFiles.map((file, index) => (
                    <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                      <div className="flex items-center gap-2">
                        <FileText className="h-4 w-4 text-blue-600" />
                        <span className="text-sm truncate max-w-[200px]">{file.name}</span>
                        <span className="text-xs text-gray-400">({(file.size / 1024).toFixed(1)} KB)</span>
                      </div>
                      <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        onClick={() => removeTaskUpdateFile(index)}
                      >
                        <X className="h-4 w-4 text-red-500" />
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setTaskUpdateModal(false)}>İptal</Button>
            <Button 
              onClick={handleSubmitTaskUpdate}
              className="bg-blue-600 hover:bg-blue-700"
              disabled={submittingTaskUpdate || !taskUpdateText.trim()}
              data-testid="submit-task-update"
            >
              {submittingTaskUpdate ? (
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              ) : (
                <CheckCircle className="h-4 w-4 mr-2" />
              )}
              Güncellemeyi Kaydet
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HRJobs;
